import LANGS from "../i18n/langs";

export const policies = [
  {
    type: "self_drive",
    textEn: `<section class="policy">
    <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">CAR WITHOUT DRIVER POLICY</h1>
  <h2>Price Include</h2>
  <ol>
    <li>Transport (car/bike)</li>
  </ol>

  <h2 style="margin-top:8px">Price Not Include</h2>
  <ol>
    <li>Driver</li>
    <li>Fuel</li>
    <li>Parking within the city, Toll</li>
    <li>Personal expenses</li>
  </ol>

  <h2 style="margin-top:8px">Price</h2>
  <ol>
    <li>5% discount for new members</li>
    <li>Free vehicle delivery and return fees at the Wirasana Sanur Office</li>
    <li>Vehicle delivery/return fee at the Airport/Kuta/Legian/Jimbaran/Seminyak/Denpasar: <strong>IDR 100,000</strong></li>
    <li>Vehicle delivery/return fee in Uluwatu/Canggu/Pererenan/Ubud/Gianyar/Nusa Dua/Benoa: <strong>IDR 150,000</strong></li>
    <li>Vehicle delivery/return fee in Tabanan/Padang Bai/Kintamani: <strong>IDR 300,000</strong></li>
    <li>Vehicle delivery/return fee in Amed/Tulamben/Negara/Lovina: <strong>IDR 450,000</strong></li>
    <li>Prices differ on national holidays, weekends, and holidays</li>
    <li>Cost of renting a driver for tour:
      <ul>
        <li>IDR 300,000 / 12 hours</li>
        <li>IDR 250,000 / 6 hours (Driver Only)</li>
      </ul>
    </li>
    <li>Latest year unit guarantee: <strong>IDR 75,000/day</strong></li>
    <li>Diesel unit guarantee: <strong>IDR 75,000/day</strong></li>
    <li>Request for wedding flower decoration on car: <strong>IDR 500,000</strong></li>
    <li>Add-on driver for the tour:
      <ul>
        <li>IDR 300,000 / 12 hours</li>
        <li>IDR 250,000 / 6 hours (Driver Only)</li>
      </ul>
    </li>
  </ol>

  <h2 style="margin-top:8px">Not Include</h2>
  <ul>
    <li>Meal allowance</li>
    <li>Overtime</li>
    <li>Transport to location</li>
    <li>Parking, Tolls & Tourist Levy</li>
    <li>Accommodation</li>
    <li>Driver Tips</li>
    <li>Personal expenses</li>
  </ul>

  <h2 style="margin-top:8px">Overtime Price/Hour</h2>
  <p><em>(Excess rental time of more than 2 hours is counted as 1 rental day)</em></p>
  <ul>
    <li><strong>IDR 10,000/hour</strong>: Vario, Scoopy</li>
    <li><strong>IDR 20,000/hour</strong>: X Max, N Max, PCX</li>
    <li><strong>IDR 50,000/hour</strong>: Agya, Calya, Avanza, Xenia, Yaris, Vespa</li>
    <li><strong>IDR 65,000/hour</strong>: Expander, Ertiga, Mobilio, Terios, Raize, Rush</li>
    <li><strong>IDR 75,000/hour</strong>: Innova, Reborn, Altis, Vios, Jazz, Veloz</li>
    <li><strong>IDR 100,000/hour</strong>: Fortuner, Pajero, Camry, Alphard</li>
    <li><strong>IDR 200,000/hour</strong>: Hiace</li>
    <li><strong>IDR 300,000/hour</strong>: Alphard Transformer</li>
  </ul>

  <h2 style="margin-top:8px">Vehicle Rental Extensions and Reschedule</h2>
  <ol>
    <li>Use of the unit is only for the Bali area.</li>
    <li>
      To extend the unit rental more than 2 times, please verify and confirm at the Wirasana Rent A Car Denpasar office 
      (Jl. Bypass Ngurah Rai No. 162, Sanur Kaja, South Denpasar).
    </li>
    <li>
      Reschedule in location for pick-up/return units cannot be confirmed if notification is less than 
      <strong>1 x 24 hours</strong> before the booking schedule (to avoid operational errors).
    </li>
    <li>Reschedule of date/time of pick-up/return will be charged <strong>IDR 100,000</strong> (maximum 2 times).</li>
    <li>
      Rental vehicle units cannot be transferred/used other than by the renter who signs the rental contract. 
      (If misused as evidence, a daily rental fee will be charged).
    </li>
    <li>If there is more than one driver, an additional fee of <strong>IDR 50,000/ID/day</strong> will apply.</li>
  </ol>
    <h2 style="margin-top:8px">Damage</h2>
  <ol>
    <li>Tire damage due to misuse/use other than on asphalt roads will be charged starting from <strong>IDR 1,000,000/tire</strong>.</li>
    <li>If there is a new scratch on the unit, there will be a charge of <strong>IDR 750,000/accident</strong> (price does not include insurance in the own risk charge).</li>
    <li>If you experience problems running out of fuel in the middle of the journey, there is a handling fee of <strong>IDR 250,000</strong> for inner city areas and starting from <strong>IDR 500,000</strong> for outer city areas.</li>
    <li>Do not park your vehicle under trees/locations that endanger the vehicle's position.</li>
    <li>If a fuel filling error occurs, there is a repair fee of <strong>IDR 2,500,000</strong>.</li>
    <li>If we do not receive information regarding the need for vehicle repair assistance during rental, then we will not accept reimbursement from any repair shop without approval/discussion.</li>
    <li>Towing car costs and car rental costs while it is being repaired are not included in the own risk charge. There will be a charge starting from <strong>IDR 1,000,000</strong> (depending on your location at that time).</li>
    <li>If there is a problem with the vehicle, our mechanic team will try to catch up and help you for a maximum of 4 hours (depending on your location at that time).</li>
  </ol>

  <h2 style="margin-top:8px">Lost</h2>
  <ol>
    <li>Losing an umbrella will be charged <strong>IDR 100,000/umbrella</strong>.</li>
    <li>Losing a Baby Car Seat will be charged <strong>IDR 4,000,000/unit</strong>.</li>
    <li>Losing the Vehicle Registration Document will be charged <strong>IDR 1,500,000</strong>.</li>
    <li>Losing a photocopy of the Vehicle Registration Document will be charged <strong>IDR 5,000</strong>.</li>
    <li>Losing a number plate will be charged starting from <strong>IDR 250,000</strong>.</li>
    <li>Losing car keys will be charged starting from <strong>IDR 2,500,000</strong>.</li>
  </ol>

  <h2 style="margin-top:8px">Return Unit</h2>
  <ol>
    <li>Lack of fuel when returning the unit will be charged <strong>IDR 100,000/box</strong> or <strong>IDR 250,000/stripe</strong>.</li>
    <li>If there is a smell of durian/vomit/cigarettes/any unpleasant smell/wet vehicle seats in the return unit, there will be a charge starting from <strong>IDR 1,500,000</strong>.</li>
    <li>If the return unit is very dirty, there is a cleaning fee starting from <strong>IDR 150,000</strong>.</li>
    <li>
      If the unit is finished earlier than the committed schedule (without prior confirmation within 3 days or not for emergency reasons), it will still be considered completed according to schedule.  
      The remaining rental days cannot be refunded/transferred to another day and will be considered forfeited.
    </li>
  </ol>

  <h2 style="margin-top:8px">Cancellation Policy</h2>
  <ol>
    <li>Cancellation on the Day → <strong>Payment is non-refundable</strong>.</li>
    <li>Cancellation within the H-1 period → <strong>50% refund</strong>.</li>
    <li>Cancellation within the H-7 period → <strong>100% refund</strong>.</li>
  </ol>
   <h2 style="margin-top:8px">Self Drive Documents Requirements</h2>
<ol>
 <li>ID/KTP/Passport/KITAS (expat)</li>
 <li>SIM A/ SIM B1/ International Driving License (valid)</li>
 <li>Any social media account</li>
 <li>Hotel and Return flight reservations</li>
 <li>2 Emergency contacts who join and who did not join the trip during rental period (Name and relation)</li>
 <li>Refundable security deposit IDR 750,000 (will be returned within 7 working days after the rental period ends, not include national holiday and holiday)</li>
 <li>If the Driving License is no longer valid, the deposit that must be paid is IDR 1,500,000</li>
  </ol>
</section>
`,
    textId: `<section class="policy">
    <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">KEBIJAKAN PENYEWAAN MOBIL TANPA SUPIR</h1>
  
  <h2>Harga Termasuk</h2>
  <ol>
    <li>Transportasi (mobil/motor)</li>
  </ol>

  <h2 style="margin-top:8px">Harga Tidak Termasuk</h2>
  <ol>
    <li>Sopir</li>
    <li>Bahan bakar</li>
    <li>Parkir dalam kota, Tol</li>
    <li>Biaya pribadi</li>
  </ol>

  <h2 style="margin-top:8px">Harga</h2>
  <ol>
    <li>Diskon 5% untuk member baru</li>
    <li>Gratis biaya pengantaran dan pengembalian kendaraan di Kantor Wirasana Sanur</li>
    <li>Biaya pengantaran/pengembalian kendaraan di Bandung/Kuta/Legian/Jimbaran/Seminyak/Denpasar: <strong>Rp 100.000</strong></li>
    <li>Biaya pengantaran/pengembalian kendaraan di Uluwatu/Canggu/Pererenan/Ubud/Gianyar/Nusa Dua/Benoa: <strong>Rp 150.000</strong></li>
    <li>Biaya pengantaran/pengembalian kendaraan di Tabanan/Padang Bai/Kintamani: <strong>Rp 300.000</strong></li>
    <li>Biaya pengantaran/pengembalian kendaraan di Amed/Tulamben/Negara/Lovina: <strong>Rp 450.000</strong></li>
    <li>Harga berbeda pada hari libur nasional, akhir pekan, dan hari libur</li>
    <li>Biaya sewa sopir untuk tur:
      <ul>
        <li>Rp 300.000 / 10 jam</li>
        <li>Rp 250.000 / 6 jam (Sopir Saja)</li>
      </ul>
    </li>
    <li>Garansi unit tahun terbaru: <strong>Rp 75.000/hari</strong></li>
    <li>Garansi unit diesel: <strong>Rp 75.000/hari</strong></li>
    <li>Permintaan dekorasi bunga pernikahan di mobil: <strong>Rp 500.000</strong></li>
    <li>Tambahan sopir untuk tur:
      <ul>
        <li>Rp 300.000 / 10 jam</li>
        <li>Rp 250.000 / 6 jam (Sopir Saja)</li>
      </ul>
    </li>
  </ol>

  <h2 style="margin-top:8px">Tidak Termasuk</h2>
  <ul>
    <li>Uang makan</li>
    <li>Lembur</li>
    <li>Transportasi ke lokasi</li>
    <li>Parkir, Tol & Levy Wisatawan</li>
    <li>Akomodasi</li>
    <li>Tip Sopir</li>
    <li>Biaya pribadi</li>
  </ul>

  <h2 style="margin-top:8px">Harga Lembur/Jam</h2>
  <p><em>(Kelebihan waktu sewa lebih dari 2 jam dihitung sebagai 1 hari sewa)</em></p>
  <ul>
    <li><strong>Rp 10.000/jam</strong>: Vario, Scoopy</li>
    <li><strong>Rp 20.000/jam</strong>: X Max, N Max, PCX</li>
    <li><strong>Rp 50.000/jam</strong>: Agya, Calya, Avanza, Xenia, Yaris, Vespa</li>
    <li><strong>Rp 65.000/jam</strong>: Expander, Ertiga, Mobilio, Terios, Raize, Rush</li>
    <li><strong>Rp 75.000/jam</strong>: Innova, Reborn, Altis, Vios, Jazz, Veloz</li>
    <li><strong>Rp 100.000/jam</strong>: Fortuner, Pajero, Camry, Alphard</li>
    <li><strong>Rp 200.000/jam</strong>: Hiace</li>
    <li><strong>Rp 300.000/jam</strong>: Alphard Transformer</li>
  </ul>

  <h2 style="margin-top:8px">Perpanjangan dan Penjadwalan Ulang Sewa Kendaraan</h2>
  <ol>
    <li>Penggunaan unit hanya untuk area Bali.</li>
    <li>Untuk memperpanjang sewa unit lebih dari 2 kali, harap verifikasi dan konfirmasi di kantor Wirasana Rent A Car Denpasar (Jl. Bypass Ngurah Rai No. 162, Sanur Kaja, Denpasar Selatan).</li>
    <li>Penjadwalan ulang lokasi untuk pengambilan/pengembalian unit tidak dapat dikonfirmasi jika pemberitahuan kurang dari <strong>1 x 24 jam</strong> sebelum jadwal pemesanan (untuk menghindari kesalahan operasional).</li>
    <li>Penjadwalan ulang tanggal/waktu pengambilan/pengembalian akan dikenakan biaya <strong>Rp 100.000</strong> (maksimal 2 kali).</li>
    <li>Unit kendaraan sewa tidak dapat dialihkan/digunakan selain oleh penyewa yang menandatangani kontrak sewa. (Jika disalahgunakan sebagai bukti, akan dikenakan biaya sewa harian).</li>
    <li>Jika terdapat lebih dari satu pengemudi, akan dikenakan biaya tambahan <strong>Rp 50.000/KTP/hari</strong>.</li>
  </ol>

  <h2 style="margin-top:8px">Kerusakan</h2>
  <ol>
    <li>Kerusakan ban akibat penyalahgunaan/penggunaan selain di jalan aspal akan dikenakan biaya mulai dari <strong>Rp 1.000.000/ban</strong>.</li>
    <li>Jika terdapat baret baru pada unit, akan dikenakan biaya <strong>Rp 750.000/kejadian</strong> (harga tidak termasuk asuransi dalam biaya own risk).</li>
    <li>Jika mengalami masalah kehabisan bensin di tengah perjalanan, ada biaya penanganan <strong>Rp 250.000</strong> untuk area dalam kota dan mulai dari <strong>Rp 500.000</strong> untuk area luar kota.</li>
    <li>Jangan memarkir kendaraan di bawah pohon/lokasi yang membahayakan posisi kendaraan.</li>
    <li>Jika terjadi kesalahan pengisian bahan bakar, ada biaya perbaikan <strong>Rp 2.500.000</strong>.</li>
    <li>Jika kami tidak menerima informasi mengenai kebutuhan bantuan perbaikan kendaraan selama masa sewa, maka kami tidak akan menerima penggantian biaya dari bengkel manapun tanpa persetujuan/diskusi.</li>
    <li>Biaya derek mobil dan biaya sewa mobil selama diperbaiki tidak termasuk dalam biaya own risk. Akan dikenakan biaya mulai dari <strong>Rp 1.000.000</strong> (tergantung lokasi Anda pada saat itu).</li>
    <li>Jika ada masalah dengan kendaraan, tim mekanik kami akan berusaha menyusul dan membantu Anda maksimal 4 jam (tergantung lokasi Anda pada saat itu).</li>
  </ol>

  <h2 style="margin-top:8px">Kehilangan</h2>
  <ol>
    <li>Kehilangan payung akan dikenakan biaya <strong>Rp 100.000/payung</strong>.</li>
    <li>Kehilangan Baby Car Seat akan dikenakan biaya <strong>Rp 4.000.000/unit</strong>.</li>
    <li>Kehilangan STNK asli kendaraan akan dikenakan biaya <strong>Rp 1.500.000</strong>.</li>
    <li>Kehilangan fotokopi STNK kendaraan akan dikenakan biaya <strong>Rp 5.000</strong>.</li>
    <li>Kehilangan plat nomor akan dikenakan biaya mulai dari <strong>Rp 250.000</strong>.</li>
    <li>Kehilangan kunci mobil akan dikenakan biaya mulai dari <strong>Rp 2.500.000</strong>.</li>
  </ol>

  <h2 style="margin-top:8px">Pengembalian Unit</h2>
  <ol>
    <li>Kekurangan bensin saat mengembalikan unit akan dikenakan biaya <strong>Rp 100.000/kotak</strong> atau <strong>Rp 250.000/garis</strong>.</li>
    <li>Jika terdapat bau durian/muntah/rokok/bau tidak sedap apapun/kursi kendaraan basah pada unit yang dikembalikan, akan dikenakan biaya mulai dari <strong>Rp 1.500.000</strong>.</li>
    <li>Jika unit pengembalian sangat kotor, ada biaya kebersihan mulai dari <strong>Rp 150.000</strong>.</li>
    <li>Jika unit selesai lebih awal dari jadwal yang dijanjikan (tanpa konfirmasi sebelumnya dalam 3 hari atau bukan karena alasan darurat), maka tetap akan dianggap selesai sesuai jadwal. Sisa hari sewa tidak dapat dikembalikan/dipindahkan ke hari lain dan akan dianggap hangus.</li>
  </ol>

  <h2 style="margin-top:8px">Kebijakan Pembatalan</h2>
  <ol>
    <li>Pembatalan pada Hari-H → <strong>Pembayaran tidak dapat dikembalikan</strong>.</li>
    <li>Pembatalan dalam periode H-1 → <strong>Pengembalian 50%</strong>.</li>
    <li>Pembatalan dalam periode H-7 → <strong>Pengembalian 100%</strong>.</li>
  </ol>
  <h2 style="margin-top:8px">Persyaratan Dokumen Sewa Mobil Lepas Kunci</h2>
  <ol>
  <li>KTP/Passport/KITAS (untuk ekspatriat)</li>
  <li>SIM A / SIM B1 / SIM Internasional (masih berlaku)</li>
  <li>Akun media sosial apa pun</li>
  <li>Reservasi hotel dan tiket pesawat pulang</li>
  <li>2 kontak darurat yang ikut dan tidak ikut dalam perjalanan selama masa sewa (Nama dan hubungan)</li>
  <li>Deposit jaminan dapat dikembalikan sebesar Rp750.000 (akan dikembalikan dalam waktu 7 hari kerja setelah masa sewa berakhir, tidak termasuk hari libur nasional dan hari libur lainnya)</li>
  <li>Jika SIM tidak lagi berlaku, deposit yang harus dibayarkan adalah Rp1.500.000</li>
  </ol>
</section>`,

    textDe: `<section class="policy">
    <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">RICHTLINIEN FÜR MIETWAGEN OHNE FAHRER</h1>
  
  <h2>Im Preis inbegriffen</h2>
  <ol>
    <li>Transportmittel (Auto/Motorrad)</li>
  </ol>

  <h2 style="margin-top:8px">Nicht im Preis inbegriffen</h2>
  <ol>
    <li>Fahrer</li>
    <li>Kraftstoff</li>
    <li>Stadtparkgebühren, Maut</li>
    <li>Persönliche Ausgaben</li>
  </ol>

  <h2 style="margin-top:8px">Preise</h2>
  <ol>
    <li>5% Rabatt für neue Mitglieder</li>
    <li>Kostenlose Fahrzeugzustellung und Rückgabegebühren im Wirasana Sanur Büro</li>
    <li>Fahrzeugzustellungs-/Rückgabegebühr am Flughafen/Kuta/Legian/Jimbaran/Seminyak/Denpasar: <strong>IDR 100.000</strong></li>
    <li>Fahrzeugzustellungs-/Rückgabegebühr in Uluwatu/Canggu/Pererenan/Ubud/Gianyar/Nusa Dua/Benoa: <strong>IDR 150.000</strong></li>
    <li>Fahrzeugzustellungs-/Rückgabegebühr in Tabanan/Padang Bai/Kintamani: <strong>IDR 300.000</strong></li>
    <li>Fahrzeugzustellungs-/Rückgabegebühr in Amed/Tulamben/Negara/Lovina: <strong>IDR 450.000</strong></li>
    <li>Preise unterscheiden sich an nationalen Feiertagen, Wochenenden und Feiertagen</li>
    <li>Kosten für die Anmietung eines Fahrers für die Tour:
      <ul>
        <li>IDR 300.000 / 12 Stunden</li>
        <li>IDR 250.000 / 6 Stunden (Nur Fahrer)</li>
      </ul>
    </li>
    <li>Garantie für neueste Modelle: <strong>IDR 75.000/Tag</strong></li>
    <li>Diesel-Einheitengarantie: <strong>IDR 75.000/Tag</strong></li>
    <li>Anfrage für Hochzeitsblumendekoration am Auto: <strong>IDR 500.000</strong></li>
    <li>Zusätzlicher Fahrer für die Tour:
      <ul>
        <li>IDR 300.000 / 12 Stunden</li>
        <li>IDR 250.000 / 6 Stunden (Nur Fahrer)</li>
      </ul>
    </li>
  </ol>

  <h2 style="margin-top:8px">Nicht inbegriffen</h2>
  <ul>
    <li>Verpflegungspauschale</li>
    <li>Überstunden</li>
    <li>Transport zum Standort</li>
    <li>Parken, Maut & Touristenabgabe</li>
    <li>Unterkunft</li>
    <li>Fahrertrinkgeld</li>
    <li>Persönliche Ausgaben</li>
  </ul>

  <h2 style="margin-top:8px">Überstundenpreis/Stunde</h2>
  <p><em>(Mehr Mietzeit von mehr als 2 Stunden wird als 1 Miettag gezählt)</em></p>
  <ul>
    <li><strong>IDR 10.000/Stunde</strong>: Vario, Scoopy</li>
    <li><strong>IDR 20.000/Stunde</strong>: X Max, N Max, PCX</li>
    <li><strong>IDR 50.000/Stunde</strong>: Agya, Calya, Avanza, Xenia, Yaris, Vespa</li>
    <li><strong>IDR 65.000/Stunde</strong>: Expander, Ertiga, Mobilio, Terios, Raize, Rush</li>
    <li><strong>IDR 75.000/Stunde</strong>: Innova, Reborn, Altis, Vios, Jazz, Veloz</li>
    <li><strong>IDR 100.000/Stunde</strong>: Fortuner, Pajero, Camry, Alphard</li>
    <li><strong>IDR 200.000/Stunde</strong>: Hiace</li>
    <li><strong>IDR 300.000/Stunde</strong>: Alphard Transformer</li>
  </ul>

  <h2 style="margin-top:8px">Fahrzeugmietverlängerungen und Neuplanung</h2>
  <ol>
    <li>Die Nutzung der Einheit ist nur für den Bereich Bali vorgesehen.</li>
    <li>Um die Einheitsmiete mehr als zweimal zu verlängern, verifizieren und bestätigen Sie dies bitte im Wirasana Rent A Car Denpasar Büro (Jl. Bypass Ngurah Rai No. 162, Sanur Kaja, Süd-Denpasar).</li>
    <li>Die Neuplanung des Standorts für die Abholung/Rückgabe von Einheiten kann nicht bestätigt werden, wenn die Benachrichtigung weniger als <strong>1 x 24 Stunden</strong> vor dem Buchungszeitpunkt erfolgt (um Betriebsfehler zu vermeiden).</li>
    <li>Die Neuplanung des Datums/der Uhrzeit der Abholung/Rückgabe wird mit <strong>IDR 100.000</strong> berechnet (maximal 2 Mal).</li>
    <li>Fahrzeugmieteinheiten können nicht von anderen als dem Mieter, der den Mietvertrag unterzeichnet, transferiert/genutzt werden. (Bei missbräuchlicher Nutzung als Beweismittel wird eine tägliche Mietgebühr berechnet).</li>
    <li>Wenn es mehr als einen Fahrer gibt, gilt eine zusätzliche Gebühr von <strong>IDR 50.000/Ausweis/Tag</strong>.</li>
  </ol>

  <h2 style="margin-top:8px">Schäden</h2>
  <ol>
    <li>Reifenschäden durch Missbrauch/Nutzung abseits von Asphaltstraßen werden ab <strong>IDR 1.000.000/Reifen</strong> berechnet.</li>
    <li>Bei neuen Kratzern an der Einheit wird eine Gebühr von <strong>IDR 750.000/Vorfall</strong> erhoben (Preis beinhaltet keine Versicherung im Eigenrisiko).</li>
    <li>Bei Kraftstoffmangel mitten auf der Strecke fällt eine Bearbeitungsgebühr von <strong>IDR 250.000</strong> für innerstädtische Gebiete und ab <strong>IDR 500.000</strong> für außerstädtische Gebiete an.</li>
    <li>Parken Sie Ihr Fahrzeug nicht unter Bäumen/an Orten, die die Fahrzeugposition gefährden.</li>
    <li>Bei Fehlbetankung fällt eine Reparaturgebühr von <strong>IDR 2.500.000</strong> an.</li>
    <li>Wenn wir keine Informationen über die Notwendigkeit von Fahrzeugreparaturhilfe während der Mietzeit erhalten, akzeptieren wir keine Erstattung von irgendeiner Werkstatt ohne Genehmigung/Diskussion.</li>
    <li>Abschleppkosten und Mietwagenkosten während der Reparatur sind nicht in der Eigenrisikogebühr enthalten. Es wird eine Gebühr ab <strong>IDR 1.000.000</strong> erhoben (abhängig von Ihrem Standort zu diesem Zeitpunkt).</li>
    <li>Bei Problemen mit dem Fahrzeug wird sich unser Mechanikerteam bemühen, Sie innerhalb von maximal 4 Stunden einzuholen und zu unterstützen (abhängig von Ihrem Standort zu diesem Zeitpunkt).</li>
  </ol>

  <h2 style="margin-top:8px">Verlust</h2>
  <ol>
    <li>Der Verlust eines Regenschirms wird mit <strong>IDR 100.000/Schirm</strong> berechnet.</li>
    <li>Der Verlust eines Kindersitzes wird mit <strong>IDR 4.000.000/Einheit</strong> berechnet.</li>
    <li>Der Verlust des Fahrzeugscheins wird mit <strong>IDR 1.500.000</strong> berechnet.</li>
    <li>Der Verlust einer Kopie des Fahrzeugscheins wird mit <strong>IDR 5.000</strong> berechnet.</li>
    <li>Der Verlust eines Nummernschilds wird ab <strong>IDR 250.000</strong> berechnet.</li>
    <li>Der Verlust von Autoschlüsseln wird ab <strong>IDR 2.500.000</strong> berechnet.</li>
  </ol>

  <h2 style="margin-top:8px">Rückgabe der Einheit</h2>
  <ol>
    <li>Kraftstoffmangel bei Rückgabe der Einheit wird mit <strong>IDR 100.000/Kästchen</strong> oder <strong>IDR 250.000/Strich</strong> berechnet.</li>
    <li>Bei Durian-/Erbrochenen-/Zigaretten-/unangenehmen Gerüchen/nassen Fahrzeugsitzen bei Rückgabe wird eine Gebühr ab <strong>IDR 1.500.000</strong> erhoben.</li>
    <li>Wenn die zurückgegebene Einheit sehr schmutzig ist, fällt eine Reinigungsgebühr ab <strong>IDR 150.000</strong> an.</li>
    <li>Wenn die Einheit früher als der vereinbarte Zeitplan beendet wird (ohne vorherige Bestätigung innerhalb von 3 Tagen oder nicht aus Notfallgründen), gilt sie dennoch als planmäßig beendet. Die restlichen Miettage können nicht erstattet/auf einen anderen Tag übertragen werden und gelten als verfallen.</li>
  </ol>

  <h2 style="margin-top:8px">Stornierungsbedingungen</h2>
  <ol>
    <li>Stornierung am Tag → <strong>Zahlung ist nicht erstattungsfähig</strong>.</li>
    <li>Stornierung innerhalb der Frist H-1 → <strong>50% Rückerstattung</strong>.</li>
    <li>Stornierung innerhalb der Frist H-7 → <strong>100% Rückerstattung</strong>.</li>
  </ol>
  <h2 style="margin-top:8px">ERFORDERLICHE DOKUMENTE FÜR SELBSTFAHRER</h2>
<ol>
  <li>Personalausweis/Reisepass/KITAS (für Expats)</li>
  <li>Führerschein Klasse A/B1 oder internationaler Führerschein (gültig)</li>
  <li>Beliebiges soziales Medienkonto</li>
  <li>Hotel- und Rückflugreservierungen</li>
  <li>Zwei Notfallkontakte – einer, der mitreist, und einer, der nicht mitreist (Name und Beziehung)</li>
  <li>Rückzahlbare Kaution in Höhe von 750.000 IDR (wird innerhalb von 7 Arbeitstagen nach Ende der Mietdauer zurückerstattet, ausgenommen nationale Feiertage und Ferien)</li>
  <li>Wenn der Führerschein nicht mehr gültig ist, muss eine Kaution von 1.500.000 IDR hinterlegt werden</li>
</ol>

</section>`,

    textFr: `<section class="policy">
    <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">POLITIQUE DE LOCATION DE VOITURE SANS CHAUFFEUR</h1>
  
  <h2>Prix Inclus</h2>
  <ol>
    <li>Transport (voiture/moto)</li>
  </ol>

  <h2 style="margin-top:8px">Prix Non Inclus</h2>
  <ol>
    <li>Chauffeur</li>
    <li>Carburant</li>
    <li>Stationnement en ville, Péage</li>
    <li>Dépenses personnelles</li>
  </ol>

  <h2 style="margin-top:8px">Prix</h2>
  <ol>
    <li>5% de réduction pour les nouveaux membres</li>
    <li>Frais de livraison et de retour du véhicule gratuits au Bureau Wirasana Sanur</li>
    <li>Frais de livraison/retour du véhicule à l'Aéroport/Kuta/Legian/Jimbaran/Seminyak/Denpasar: <strong>IDR 100.000</strong></li>
    <li>Frais de livraison/retour du véhicule à Uluwatu/Canggu/Pererenan/Ubud/Gianyar/Nusa Dua/Benoa: <strong>IDR 150.000</strong></li>
    <li>Frais de livraison/retour du véhicule à Tabanan/Padang Bai/Kintamani: <strong>IDR 300.000</strong></li>
    <li>Frais de livraison/retour du véhicule à Amed/Tulamben/Negara/Lovina: <strong>IDR 450.000</strong></li>
    <li>Les prix diffèrent les jours fériés nationaux, week-ends et jours fériés</li>
    <li>Coût de location d'un chauffeur pour la visite:
      <ul>
        <li>IDR 300.000 / 12 heures</li>
        <li>IDR 250.000 / 6 heures (Chauffeur Seulement)</li>
      </ul>
    </li>
    <li>Garantie unité de dernière année: <strong>IDR 75.000/jour</strong></li>
    <li>Garantie unité diesel: <strong>IDR 75.000/jour</strong></li>
    <li>Demande de décoration florale de mariage sur la voiture: <strong>IDR 500.000</strong></li>
    <li>Chauffeur supplémentaire pour la visite:
      <ul>
        <li>IDR 300.000 / 12 heures</li>
        <li>IDR 250.000 / 6 heures (Chauffeur Seulement)</li>
      </ul>
    </li>
  </ol>

  <h2 style="margin-top:8px">Non Inclus</h2>
  <ul>
    <li>Indemnité repas</li>
    <li>Heures supplémentaires</li>
    <li>Transport vers le lieu</li>
    <li>Stationnement, Péage & Taxe Touristique</li>
    <li>Hébergement</li>
    <li>Pourboire du chauffeur</li>
    <li>Dépenses personnelles</li>
  </ul>

  <h2 style="margin-top:8px">Prix Heures Supplémentaires/Heure</h2>
  <p><em>(Un excédent de temps de location de plus de 2 heures est compté comme 1 jour de location)</em></p>
  <ul>
    <li><strong>IDR 10.000/heure</strong>: Vario, Scoopy</li>
    <li><strong>IDR 20.000/heure</strong>: X Max, N Max, PCX</li>
    <li><strong>IDR 50.000/heure</strong>: Agya, Calya, Avanza, Xenia, Yaris, Vespa</li>
    <li><strong>IDR 65.000/heure</strong>: Expander, Ertiga, Mobilio, Terios, Raize, Rush</li>
    <li><strong>IDR 75.000/heure</strong>: Innova, Reborn, Altis, Vios, Jazz, Veloz</li>
    <li><strong>IDR 100.000/heure</strong>: Fortuner, Pajero, Camry, Alphard</li>
    <li><strong>IDR 200.000/heure</strong>: Hiace</li>
    <li><strong>IDR 300.000/heure</strong>: Alphard Transformer</li>
  </ul>

  <h2 style="margin-top:8px">Prolongations et Réplanification de Location de Véhicule</h2>
  <ol>
    <li>L'utilisation de l'unité est uniquement pour la zone de Bali.</li>
    <li>Pour prolonger la location de l'unité plus de 2 fois, veuillez vérifier et confirmer au bureau Wirasana Rent A Car Denpasar (Jl. Bypass Ngurah Rai No. 162, Sanur Kaja, Denpasar Sud).</li>
    <li>La réplanification du lieu de prise/retour des unités ne peut être confirmée si la notification est inférieure à <strong>1 x 24 heures</strong> avant l'horaire de réservation (pour éviter les erreurs opérationnelles).</li>
    <li>La réplanification de la date/heure de prise/retour sera facturée <strong>IDR 100.000</strong> (maximum 2 fois).</li>
    <li>Les unités de véhicule de location ne peuvent être transférées/utilisées par d'autres que le locataire qui signe le contrat de location. (En cas d'utilisation abusive comme preuve, des frais de location journaliers seront facturés).</li>
    <li>S'il y a plus d'un conducteur, des frais supplémentaires de <strong>IDR 50.000/pièce d'identité/jour</strong> s'appliqueront.</li>
  </ol>

  <h2 style="margin-top:8px">Dommages</h2>
  <ol>
    <li>Les dommages aux pneus dus à une mauvaise utilisation/utilisation en dehors des routes asphaltées seront facturés à partir de <strong>IDR 1.000.000/pneu</strong>.</li>
    <li>S'il y a une nouvelle rayure sur l'unité, des frais de <strong>IDR 750.000/incident</strong> seront appliqués (le prix n'inclut pas l'assurance dans les frais de risque propre).</li>
    <li>Si vous rencontrez des problèmes de panne d'essence au milieu du trajet, des frais de traitement de <strong>IDR 250.000</strong> pour les zones intra-urbaines et à partir de <strong>IDR 500.000</strong> pour les zones extra-urbaines s'appliquent.</li>
    <li>Ne garez pas votre véhicule sous les arbres/endroits qui mettent en danger la position du véhicule.</li>
    <li>En cas d'erreur de remplissage de carburant, des frais de réparation de <strong>IDR 2.500.000</strong> s'appliquent.</li>
    <li>Si nous ne recevons pas d'information concernant le besoin d'assistance à la réparation du véhicule pendant la location, nous n'accepterons aucun remboursement de la part d'un atelier de réparation sans approbation/discussion.</li>
    <li>Les coûts de remorquage et de location de voiture pendant la réparation ne sont pas inclus dans les frais de risque propre. Des frais à partir de <strong>IDR 1.000.000</strong> seront appliqués (en fonction de votre localisation à ce moment-là).</li>
    <li>En cas de problème avec le véhicule, notre équipe de mécaniciens tentera de vous rattraper et de vous aider pendant un maximum de 4 heures (en fonction de votre localisation à ce moment-là).</li>
  </ol>

  <h2 style="margin-top:8px">Perte</h2>
  <ol>
    <li>La perte d'un parapluie sera facturée <strong>IDR 100.000/parapluie</strong>.</li>
    <li>La perte d'un siège auto bébé sera facturée <strong>IDR 4.000.000/unité</strong>.</li>
    <li>La perte du document d'immatriculation du véhicule sera facturée <strong>IDR 1.500.000</strong>.</li>
    <li>La perte d'une photocopie du document d'immatriculation du véhicule sera facturée <strong>IDR 5.000</strong>.</li>
    <li>La perte d'une plaque d'immatriculation sera facturée à partir de <strong>IDR 250.000</strong>.</li>
    <li>La perte des clés de voiture sera facturée à partir de <strong>IDR 2.500.000</strong>.</li>
  </ol>

  <h2 style="margin-top:8px">Retour de l'Unité</h2>
  <ol>
    <li>Le manque de carburant lors du retour de l'unité sera facturé <strong>IDR 100.000/boîte</strong> ou <strong>IDR 250.000/trait</strong>.</li>
    <li>S'il y a une odeur de durian/vomi/cigarette/odeur désagréable/sièges de véhicule mouillés dans l'unité retournée, des frais à partir de <strong>IDR 1.500.000</strong> seront appliqués.</li>
    <li>Si l'unité retournée est très sale, des frais de nettoyage à partir de <strong>IDR 150.000</strong> s'appliquent.</li>
    <li>Si l'unité est terminée plus tôt que le calendrier convenu (sans confirmation préalable dans les 3 jours ou non pour des raisons d'urgence), elle sera toujours considérée comme terminée selon le calendrier. Les jours de location restants ne peuvent être remboursés/transférés à un autre jour et seront considérés comme perdus.</li>
  </ol>

  <h2 style="margin-top:8px">Politique d'Annulation</h2>
  <ol>
    <li>Annulation le Jour J → <strong>Le paiement est non remboursable</strong>.</li>
    <li>Annulation dans la période J-1 → <strong>Remboursement à 50%</strong>.</li>
    <li>Annulation dans la période J-7 → <strong>Remboursement à 100%</strong>.</li>
  </ol>
  <h2 style="margin-top:8px">DOCUMENTS REQUIS POUR LA LOCATION EN CONDUITE LIBRE</h2>
<ol>
  <li>Carte d’identité/Passeport/KITAS (pour les expatriés)</li>
  <li>Permis de conduire A/B1 ou permis de conduire international (valide)</li>
  <li>Compte sur un réseau social</li>
  <li>Réservations d’hôtel et de vol retour</li>
  <li>Deux contacts d’urgence — un qui participe et un qui ne participe pas au voyage (nom et relation)</li>
  <li>Dépôt de garantie remboursable de 750 000 IDR (remboursé dans les 7 jours ouvrables après la fin de la période de location, hors jours fériés)</li>
  <li>Si le permis de conduire n’est plus valide, un dépôt de 1 500 000 IDR est requis</li>
</ol>

</section>`,

    textKo: `<section class="policy">
    <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">무인 차량 렌트 정책</h1>
  
  <h2>포함 사항</h2>
  <ol>
    <li>교통수단 (차량/바이크)</li>
  </ol>

  <h2 style="margin-top:8px">불포함 사항</h2>
  <ol>
    <li>기사</li>
    <li>연료</li>
    <li>시내 주차료, 통행료</li>
    <li>개인 경비</li>
  </ol>

  <h2 style="margin-top:8px">가격</h2>
  <ol>
    <li>신규 회원 5% 할인</li>
    <li>Wirasana Sanur 사무소에서의 차량 인도/반환 수수료 무료</li>
    <li>공항/쿠타/레기안/짐바란/세미냑/덴파사르에서의 차량 인도/반환 수수료: <strong>IDR 100,000</strong></li>
    <li>울루와투/창구/페레레난/우붓/기안야르/누사두아/베노아에서의 차량 인도/반환 수수료: <strong>IDR 150,000</strong></li>
    <li>타바난/파당바이/킨타마니에서의 차량 인도/반환 수수료: <strong>IDR 300,000</strong></li>
    <li>아메드/툴람벤/네가라/로비나에서의 차량 인도/반환 수수료: <strong>IDR 450,000</strong></li>
    <li>국경일, 주말, 공휴일에는 가격이 다름</li>
    <li>투어용 기사 임대 비용:
      <ul>
        <li>IDR 300,000 / 12시간</li>
        <li>IDR 250,000 / 6시간 (기사만)</li>
      </ul>
    </li>
    <li>최신 연식 차량 보증: <strong>IDR 75,000/일</strong></li>
    <li>디젤 차량 보증: <strong>IDR 75,000/일</strong></li>
    <li>차량 웨딩 플라워 데코레이션 요청: <strong>IDR 500,000</strong></li>
    <li>투어 추가 기사:
      <ul>
        <li>IDR 300,000 / 12시간</li>
        <li>IDR 250,000 / 6시간 (기사만)</li>
      </ul>
    </li>
  </ol>

  <h2 style="margin-top:8px">불포함</h2>
  <ul>
    <li>식사 수당</li>
    <li>초과 근무</li>
    <li>현지 이동 교통비</li>
    <li>주차료, 통행료 및 관광객 부담금</li>
    <li>숙박</li>
    <li>기사 팁</li>
    <li>개인 경비</li>
  </ul>

  <h2 style="margin-top:8px">시간당 초과 이용 요금</h2>
  <p><em>(2시간 초과 사용 시 1일 렌트로 계산)</em></p>
  <ul>
    <li><strong>IDR 10,000/시간</strong>: Vario, Scoopy</li>
    <li><strong>IDR 20,000/시간</strong>: X Max, N Max, PCX</li>
    <li><strong>IDR 50,000/시간</strong>: Agya, Calya, Avanza, Xenia, Yaris, Vespa</li>
    <li><strong>IDR 65,000/시간</strong>: Expander, Ertiga, Mobilio, Terios, Raize, Rush</li>
    <li><strong>IDR 75,000/시간</strong>: Innova, Reborn, Altis, Vios, Jazz, Veloz</li>
    <li><strong>IDR 100,000/시간</strong>: Fortuner, Pajero, Camry, Alphard</li>
    <li><strong>IDR 200,000/시간</strong>: Hiace</li>
    <li><strong>IDR 300,000/시간</strong>: Alphard Transformer</li>
  </ul>

  <h2 style="margin-top:8px">차량 렌트 연장 및 일정 변경</h2>
  <ol>
    <li>차량 사용은 발리 지역으로만 제한됩니다.</li>
    <li>차량 렌트를 2회 이상 연장하려면 Wirasana Rent A Car Denpasar 사무소 (Jl. Bypass Ngurah Rai No. 162, Sanur Kaja, South Denpasar)에서 확인 및 승인을 받아야 합니다.</li>
    <li>차량 인수/반환 장소 변경은 예정 시간 <strong>24시간 미만</strong>으로 통보 시 확인되지 않습니다 (운영 오류 방지).</li>
    <li>인수/반환 일시 변경 시 <strong>IDR 100,000</strong>의 수수료가 부과됩니다 (최대 2회).</li>
    <li>렌트 계약서에 서명한 렌터 이외의 사람에게 차량을 양도/사용할 수 없습니다. (남용 시 일일 렌트 요금이 부과됨).</li>
    <li>운전자가 2명 이상일 경우 <strong>IDR 50,000/신분증/일</strong>의 추가 요금이 적용됩니다.</li>
  </ol>

  <h2 style="margin-top:8px">손해</h2>
  <ol>
    <li>오용/아스팔트 도로 이외에서 사용으로 인한 타이어 손상은 <strong>IDR 1,000,000/타이어</strong>부터 부과됩니다.</li>
    <li>차량에 새로운 흠집이 생길 경우 <strong>IDR 750,000/사고</strong>의 요금이 부과됩니다 (자가 부담금에 보험 미포함).</li>
    <li>주행 중 연료 부족 문제 발생 시 시내 지역은 <strong>IDR 250,000</strong>, 시외 지역은 <strong>IDR 500,000</strong>부터 처리 비용이 부과됩니다.</li>
    <li>차량을 나무 아래/차량 위치를 위험하게 하는 장소에 주차하지 마십시오.</li>
    <li>잘못된 연료 주유 발생 시 <strong>IDR 2,500,000</strong>의 수리 비용이 부과됩니다.</li>
    <li>렌트 기간 중 차량 수리 지원 필요성에 대한 정보를 받지 못한 경우, 승인/논의 없이 어떤 수리점에서도 비용 보상을 받지 않습니다.</li>
    <li>견인 비용 및 수리 중 렌트카 비용은 자가 부담금에 포함되지 않습니다. 당시 위치에 따라 <strong>IDR 1,000,000</strong>부터 비용이 부과됩니다.</li>
    <li>차량에 문제가 있을 경우, 당사 정비 팀이 최대 4시간 내에 따라잡아 도와드리겠습니다 (당시 위치에 따라 다름).</li>
  </ol>

  <h2 style="margin-top:8px">분실</h2>
  <ol>
    <li>우산 분실 시 <strong>IDR 100,000/우산</strong>이 부과됩니다.</li>
    <li>아동 카시트 분실 시 <strong>IDR 4,000,000/개</strong>가 부과됩니다.</li>
    <li>차량 등록 증 분실 시 <strong>IDR 1,500,000</strong>이 부과됩니다.</li>
    <li>차량 등록 증 사본 분실 시 <strong>IDR 5,000</strong>이 부과됩니다.</li>
    <li>번호판 분실 시 <strong>IDR 250,000</strong>부터 부과됩니다.</li>
    <li>차 키 분실 시 <strong>IDR 2,500,000</strong>부터 부과됩니다.</li>
  </ol>

  <h2 style="margin-top:8px">차량 반환</h2>
  <ol>
    <li>차량 반환 시 연료 부족 시 <strong>IDR 100,000/박스</strong> 또는 <strong>IDR 250,000/줄</strong>이 부과됩니다.</li>
    <li>반환 차량에서 두리안/구토/담배/불쾌한 냄새/젖은 시트 냄새가 날 경우 <strong>IDR 1,500,000</strong>부터 부과됩니다.</li>
    <li>반환 차량이 매우 더러울 경우 <strong>IDR 150,000</strong>부터 청소 비용이 부과됩니다.</li>
    <li>약속된 일정보다 일찍 반환할 경우 (3일 이내 사전 확인 없거나 비상 사유가 아닌 경우) 예정대로 완료된 것으로 간주됩니다. 남은 렌트 일수는 환불/다른 날로 이전되지 않으며 소멸된 것으로 간주됩니다.</li>
  </ol>

  <h2 style="margin-top:8px">취소 정책</h2>
  <ol>
    <li>당일 취소 → <strong>결제금 환불 불가</strong>.</li>
    <li>D-1 기간 내 취소 → <strong>50% 환불</strong>.</li>
    <li>D-7 기간 내 취소 → <strong>100% 환불</strong>.</li>
  </ol>
  <h2 style="margin-top:8px">셀프 드라이브 차량 대여 서류 요건</h2>
<ol>
  <li>신분증/여권/KITAS (외국인 거주자용)</li>
  <li>운전면허증 A/B1 또는 국제운전면허증 (유효한 상태)</li>
  <li>소셜 미디어 계정</li>
  <li>호텔 및 귀국 항공편 예약</li>
  <li>렌트 기간 동안 동행하는 사람과 동행하지 않는 사람 각각 1명씩, 총 2명의 비상 연락처 (이름 및 관계)</li>
  <li>보증금 750,000 루피아 (렌트 종료 후 7영업일 이내 환불, 공휴일 제외)</li>
  <li>운전면허증이 유효하지 않은 경우 보증금은 1,500,000 루피아입니다</li>
</ol>
</section>`,
    textNl: `<section class="policy">
    <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">BELEID AUTO ZONDER CHAUFFEUR</h1>
  
  <h2>Prijs Inclusief</h2>
  <ol>
    <li>Vervoer (auto/motor)</li>
  </ol>

  <h2 style="margin-top:8px">Prijs Niet Inclusief</h2>
  <ol>
    <li>Chauffeur</li>
    <li>Brandstof</li>
    <li>Parkeren binnen de stad, Tol</li>
    <li>Persoonlijke uitgaven</li>
  </ol>

  <h2 style="margin-top:8px">Prijs</h2>
  <ol>
    <li>5% korting voor nieuwe leden</li>
    <li>Gratis voertuigbezorging en retourkosten bij het Wirasana Sanur Kantoor</li>
    <li>Voertuigbezorging/retourkosten op de Luchthaven/Kuta/Legian/Jimbaran/Seminyak/Denpasar: <strong>IDR 100.000</strong></li>
    <li>Voertuigbezorging/retourkosten in Uluwatu/Canggu/Pererenan/Ubud/Gianyar/Nusa Dua/Benoa: <strong>IDR 150.000</strong></li>
    <li>Voertuigbezorging/retourkosten in Tabanan/Padang Bai/Kintamani: <strong>IDR 300.000</strong></li>
    <li>Voertuigbezorging/retourkosten in Amed/Tulamben/Negara/Lovina: <strong>IDR 450.000</strong></li>
    <li>Prijzen verschillen op nationale feestdagen, weekenden en feestdagen</li>
    <li>Kosten voor het huren van een chauffeur voor tour:
      <ul>
        <li>IDR 300.000 / 12 uur</li>
        <li>IDR 250.000 / 6 uur (Alleen Chauffeur)</li>
      </ul>
    </li>
    <li>Garantie nieuwste model: <strong>IDR 75.000/dag</strong></li>
    <li>Diesel unit garantie: <strong>IDR 75.000/dag</strong></li>
    <li>Aanvraag bruidsbloemdecoratie op auto: <strong>IDR 500.000</strong></li>
    <li>Extra chauffeur voor de tour:
      <ul>
        <li>IDR 300.000 / 12 uur</li>
        <li>IDR 250.000 / 6 uur (Alleen Chauffeur)</li>
      </ul>
    </li>
  </ol>

  <h2 style="margin-top:8px">Niet Inclusief</h2>
  <ul>
    <li>Maaltijdvergoeding</li>
    <li>Overwerk</li>
    <li>Vervoer naar locatie</li>
    <li>Parkeren, Tol & Toeristenbelasting</li>
    <li>Accommodatie</li>
    <li>Chauffeur fooi</li>
    <li>Persoonlijke uitgaven</li>
  </ul>

  <h2 style="margin-top:8px">Overwerk Prijs/Uur</h2>
  <p><em>(Overtollige huurtijd van meer dan 2 uur telt als 1 huurdag)</em></p>
  <ul>
    <li><strong>IDR 10.000/uur</strong>: Vario, Scoopy</li>
    <li><strong>IDR 20.000/uur</strong>: X Max, N Max, PCX</li>
    <li><strong>IDR 50.000/uur</strong>: Agya, Calya, Avanza, Xenia, Yaris, Vespa</li>
    <li><strong>IDR 65.000/uur</strong>: Expander, Ertiga, Mobilio, Terios, Raize, Rush</li>
    <li><strong>IDR 75.000/uur</strong>: Innova, Reborn, Altis, Vios, Jazz, Veloz</li>
    <li><strong>IDR 100.000/uur</strong>: Fortuner, Pajero, Camry, Alphard</li>
    <li><strong>IDR 200.000/uur</strong>: Hiace</li>
    <li><strong>IDR 300.000/uur</strong>: Alphard Transformer</li>
  </ul>

  <h2 style="margin-top:8px">Voertuigverhuur Verlengingen en Herplanning</h2>
  <ol>
    <li>Gebruik van de unit is alleen voor het Bali gebied.</li>
    <li>Om de unithuur meer dan 2 keer te verlengen, verifieer en bevestig dit bij het Wirasana Rent A Car Denpasar kantoor (Jl. Bypass Ngurah Rai No. 162, Sanur Kaja, Zuid-Denpasar).</li>
    <li>Herplanning van locatie voor ophalen/terugbrengen units kan niet worden bevestigd als melding minder dan <strong>1 x 24 uur</strong> voor het boekingsschema is (om operationele fouten te voorkomen).</li>
    <li>Herplanning van datum/tijd van ophalen/terugbrengen wordt in rekening gebracht <strong>IDR 100.000</strong> (maximaal 2 keer).</li>
    <li>Huurvoertuig units kunnen niet worden overgedragen/gebruikt door anderen dan de huurder die het huurcontract ondertekent. (Bij misbruik als bewijs wordt een dagelijkse huurprijs in rekening gebracht).</li>
    <li>Als er meer dan één bestuurder is, is een extra vergoeding van <strong>IDR 50.000/ID/dag</strong> van toepassing.</li>
  </ol>

  <h2 style="margin-top:8px">Schade</h2>
  <ol>
    <li>Bandenschade door misbruik/gebruik anders dan op asfaltwegen wordt in rekening gebracht vanaf <strong>IDR 1.000.000/band</strong>.</li>
    <li>Als er een nieuwe kras op de unit is, wordt een bedrag van <strong>IDR 750.000/incident</strong> in rekening gebracht (prijs omvat geen verzekering in de eigen risicokosten).</li>
    <li>Als u problemen ondervindt met brandstofgebrek midden in de reis, is er een afhandelingskosten van <strong>IDR 250.000</strong> voor binnenstedelijke gebieden en vanaf <strong>IDR 500.000</strong> voor buitensstedelijke gebieden.</li>
    <li>Parkeer uw voertuig niet onder bomen/locaties die de positie van het voertuig in gevaar brengen.</li>
    <li>Als er een brandstoftankfout optreedt, is er een reparatiekosten van <strong>IDR 2.500.000</strong>.</li>
    <li>Als wij geen informatie ontvangen over de behoefte aan voertuigreparatiehulp tijdens verhuur, dan accepteren wij geen vergoeding van enige reparatiewerkplaats zonder goedkeuring/overleg.</li>
    <li>Sleepkosten en autoverhuurkosten terwijl deze wordt gerepareerd, zijn niet inbegrepen in de eigen risicokosten. Er worden kosten in rekening gebracht vanaf <strong>IDR 1.000.000</strong> (afhankelijk van uw locatie op dat moment).</li>
    <li>Als er een probleem is met het voertuig, zal ons monteursteam proberen u in te halen en te helpen gedurende maximaal 4 uur (afhankelijk van uw locatie op dat moment).</li>
  </ol>

  <h2 style="margin-top:8px">Verlies</h2>
  <ol>
    <li>Verlies van een paraplu wordt in rekening gebracht <strong>IDR 100.000/paraplu</strong>.</li>
    <li>Verlies van een Baby Autostoel wordt in rekening gebracht <strong>IDR 4.000.000/unit</strong>.</li>
    <li>Verlies van het Voertuigregistratiedocument wordt in rekening gebracht <strong>IDR 1.500.000</strong>.</li>
    <li>Verlies van een kopie van het Voertuigregistratiedocument wordt in rekening gebracht <strong>IDR 5.000</strong>.</li>
    <li>Verlies van een kentekenplaat wordt in rekening gebracht vanaf <strong>IDR 250.000</strong>.</li>
    <li>Verlies van autosleutels wordt in rekening gebracht vanaf <strong>IDR 2.500.000</strong>.</li>
  </ol>

  <h2 style="margin-top:8px">Retour Unit</h2>
  <ol>
    <li>Gebrek aan brandstof bij terugbrengen van de unit wordt in rekening gebracht <strong>IDR 100.000/vak</strong> of <strong>IDR 250.000/streep</strong>.</li>
    <li>Als er een geur van durian/braaksel/sigaretten/onaangename geur/natte voertuigstoelen in de retourunit is, wordt een bedrag in rekening gebracht vanaf <strong>IDR 1.500.000</strong>.</li>
    <li>Als de retourunit erg vies is, is er een schoonmaakkosten vanaf <strong>IDR 150.000</strong>.</li>
    <li>Als de unit eerder klaar is dan het toegezegde schema (zonder voorafgaande bevestiging binnen 3 dagen of niet voor noodgevallen), wordt deze nog steeds als volgens schema voltooid beschouwd. De resterende huurdagen kunnen niet worden terugbetaald/overgedragen naar een andere dag en worden als vervallen beschouwd.</li>
  </ol>

  <h2 style="margin-top:8px">Annuleringsbeleid</h2>
  <ol>
    <li>Annulering op de Dag → <strong>Betaling is niet restitueerbaar</strong>.</li>
    <li>Annulering binnen de H-1 periode → <strong>50% restitutie</strong>.</li>
    <li>Annulering binnen de H-7 periode → <strong>100% restitutie</strong>.</li>
  </ol>
  <h2 style="margin-top:8px">VEREISTE DOCUMENTEN VOOR ZELFRIJDENDE HUUR</h2>
<ol>
  <li>ID-kaart/Paspoort/KITAS (voor expats)</li>
  <li>Rijbewijs A/B1 of internationaal rijbewijs (geldig)</li>
  <li>Een account op sociale media</li>
  <li>Hotel- en retourvluchtreserveringen</li>
  <li>Twee noodcontacten: één die meereist en één die niet meereist (naam en relatie)</li>
  <li>Terugbetaalbare borg van IDR 750.000 (wordt binnen 7 werkdagen na het einde van de huurperiode terugbetaald, exclusief feestdagen)</li>
  <li>Als het rijbewijs niet meer geldig is, bedraagt de borg IDR 1.500.000</li>
</ol>
</section>`,

    textRu: `<section class="policy">
    <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">ПОЛИТИКА АРЕНДЫ АВТОМОБИЛЯ БЕЗ ВОДИТЕЛЯ</h1>
  
  <h2>Включено в стоимость</h2>
  <ol>
    <li>Транспортное средство (автомобиль/мотоцикл)</li>
  </ol>

  <h2 style="margin-top:8px">Не включено в стоимость</h2>
  <ol>
    <li>Водитель</li>
    <li>Топливо</li>
    <li>Городская парковка, Платные дороги</li>
    <li>Личные расходы</li>
  </ol>

  <h2 style="margin-top:8px">Стоимость</h2>
  <ol>
    <li>5% скидка для новых участников</li>
    <li>Бесплатная доставка и возврат автомобиля в офисе Wirasana Sanur</li>
    <li>Стоимость доставки/возврата автомобиля в Аэропорт/Кута/Легиан/Джимбаран/Семиньяк/Денпасар: <strong>IDR 100.000</strong></li>
    <li>Стоимость доставки/возврата автомобиля в Улувату/Канггу/Переренан/Убуд/Гианьяр/Нуса-Дуа/Беноа: <strong>IDR 150.000</strong></li>
    <li>Стоимость доставки/возврата автомобиля в Табанан/Паданг-Бай/Кинтамани: <strong>IDR 300.000</strong></li>
    <li>Стоимость доставки/возврата автомобиля в Амед/Туламбен/Негара/Ловина: <strong>IDR 450.000</strong></li>
    <li>Цены отличаются в национальные праздники, выходные и праздничные дни</li>
    <li>Стоимость аренды водителя для экскурсии:
      <ul>
        <li>IDR 300.000 / 12 часов</li>
        <li>IDR 250.000 / 6 часов (Только водитель)</li>
      </ul>
    </li>
    <li>Гарантия на автомобили последнего года выпуска: <strong>IDR 75.000/день</strong></li>
    <li>Гарантия на дизельные автомобили: <strong>IDR 75.000/день</strong></li>
    <li>Запрос на цветочное украшение для свадьбы на автомобиле: <strong>IDR 500.000</strong></li>
    <li>Дополнительный водитель для экскурсии:
      <ul>
        <li>IDR 300.000 / 12 часов</li>
        <li>IDR 250.000 / 6 часов (Только водитель)</li>
      </ul>
    </li>
  </ol>

  <h2 style="margin-top:8px">Не включено</h2>
  <ul>
    <li>Суточные</li>
    <li>Сверхурочные</li>
    <li>Трансфер до места</li>
    <li>Парковка, Платные дороги & Туристический сбор</li>
    <li>Проживание</li>
    <li>Чаевые водителю</li>
    <li>Личные расходы</li>
  </ul>

  <h2 style="margin-top:8px">Стоимость сверхурочного времени/час</h2>
  <p><em>(Превышение времени аренды более 2 часов считается за 1 день аренды)</em></p>
  <ul>
    <li><strong>IDR 10.000/час</strong>: Vario, Scoopy</li>
    <li><strong>IDR 20.000/час</strong>: X Max, N Max, PCX</li>
    <li><strong>IDR 50.000/час</strong>: Agya, Calya, Avanza, Xenia, Yaris, Vespa</li>
    <li><strong>IDR 65.000/час</strong>: Expander, Ertiga, Mobilio, Terios, Raize, Rush</li>
    <li><strong>IDR 75.000/час</strong>: Innova, Reborn, Altis, Vios, Jazz, Veloz</li>
    <li><strong>IDR 100.000/час</strong>: Fortuner, Pajero, Camry, Alphard</li>
    <li><strong>IDR 200.000/час</strong>: Hiace</li>
    <li><strong>IDR 300.000/час</strong>: Alphard Transformer</li>
  </ul>

  <h2 style="margin-top:8px">Продление и перенос аренды автомобиля</h2>
  <ol>
    <li>Использование автомобиля разрешено только на территории Бали.</li>
    <li>Для продления аренды автомобиля более 2 раз, пожалуйста, подтвердите в офисе Wirasana Rent A Car Denpasar (Jl. Bypass Ngurah Rai No. 162, Sanur Kaja, Южный Денпасар).</li>
    <li>Перенос места получения/возврата автомобиля не может быть подтвержден, если уведомление поступило менее чем за <strong>1 x 24 часа</strong> до времени бронирования (во избежание операционных ошибок).</li>
    <li>Перенос даты/времени получения/возврата оплачивается <strong>IDR 100.000</strong> (максимум 2 раза).</li>
    <li>Арендованные автомобили не могут быть переданы/использованы кем-либо, кроме арендатора, подписавшего договор аренды. (В случае неправомерного использования в качестве доказательства будет взиматься плата за дневную аренду).</li>
    <li>Если водителей более одного, применяется дополнительная плата <strong>IDR 50.000/удостоверение личности/день</strong>.</li>
  </ol>

  <h2 style="margin-top:8px">Повреждения</h2>
  <ol>
    <li>Повреждение шин из-за неправильного использования/использования не на асфальтированных дорогах оплачивается от <strong>IDR 1.000.000/шина</strong>.</li>
    <li>При появлении новой царапины на автомобиле взимается плата <strong>IDR 750.000/инцидент</strong> (цена не включает страховку в стоимости собственного риска).</li>
    <li>При проблеме с отсутствием топлива в середине пути взимается плата за обслуживание <strong>IDR 250.000</strong> для внутригородских районов и от <strong>IDR 500.000</strong> для загородных районов.</li>
    <li>Не паркуйте автомобиль под деревьями/в местах, подвергающих опасности положение автомобиля.</li>
    <li>При ошибке заправки топливом взимается плата за ремонт <strong>IDR 2.500.000</strong>.</li>
    <li>Если мы не получаем информацию о необходимости помощи в ремонте автомобиля во время аренды, мы не принимаем возмещение расходов от любого ремонтного цеха без одобрения/обсуждения.</li>
    <li>Стоимость эвакуатора и аренды автомобиля во время ремонта не включены в стоимость собственного риска. Будет взиматься плата от <strong>IDR 1.000.000</strong> (в зависимости от вашего местоположения в тот момент).</li>
    <li>При возникновении проблемы с автомобилем наша команда механиков постарается догнать и помочь вам в течение максимум 4 часов (в зависимости от вашего местоположения в тот момент).</li>
  </ol>

  <h2 style="margin-top:8px">Утеря</h2>
  <ol>
    <li>Потеря зонтика оплачивается <strong>IDR 100.000/зонт</strong>.</li>
    <li>Потеря детского автокресла оплачивается <strong>IDR 4.000.000/единица</strong>.</li>
    <li>Потеря Свидетельства о регистрации транспортного средства оплачивается <strong>IDR 1.500.000</strong>.</li>
    <li>Потеря копии Свидетельства о регистрации транспортного средства оплачивается <strong>IDR 5.000</strong>.</li>
    <li>Потеря номерного знака оплачивается от <strong>IDR 250.000</strong>.</li>
    <li>Потеря ключей от автомобиля оплачивается от <strong>IDR 2.500.000</strong>.</li>
  </ol>

  <h2 style="margin-top:8px">Возврат автомобиля</h2>
  <ol>
    <li>Недостаток топлива при возврате автомобиля оплачивается <strong>IDR 100.000/деление</strong> или <strong>IDR 250.000/полоска</strong>.</li>
    <li>При наличии запаха дуриана/рвоты/сигарет/любого неприятного запаха/мокрых сидений в возвращаемом автомобиле взимается плата от <strong>IDR 1.500.000</strong>.</li>
    <li>Если возвращаемый автомобиль очень грязный, взимается плата за уборку от <strong>IDR 150.000</strong>.</li>
    <li>Если автомобиль возвращен раньше оговоренного срока (без предварительного подтверждения в течение 3 дней или не по чрезвычайным причинам), он все равно считается возвращенным по графику. Оставшиеся дни аренды не подлежат возврату/переносу на другой день и считаются утраченными.</li>
  </ol>

  <h2 style="margin-top:8px">Политика отмены</h2>
  <ol>
    <li>Отмена в день → <strong>Оплата не возвращается</strong>.</li>
    <li>Отмена в течение периода за 1 день → <strong>Возврат 50%</strong>.</li>
    <li>Отмена в течение периода за 7 дней → <strong>Возврат 100%</strong>.</li>
  </ol>
  <h2 style="margin-top:8px">ТРЕБОВАНИЯ К ДОКУМЕНТАМ ДЛЯ АРЕНДЫ АВТО БЕЗ ВОДИТЕЛЯ</h2>
<ol>
  <li>Удостоверение личности/Паспорт/KITAS (для экспатов)</li>
  <li>Водительское удостоверение категории A/B1 или международное (действительное)</li>
  <li>Любая учетная запись в социальной сети</li>
  <li>Бронирование отеля и обратного авиабилета</li>
  <li>Два экстренных контакта — один участник поездки и один не участвующий (имя и отношение)</li>
  <li>Возвращаемый залог 750 000 IDR (возвращается в течение 7 рабочих дней после окончания аренды, за исключением государственных праздников)</li>
  <li>Если водительское удостоверение недействительно, необходимо внести залог 1 500 000 IDR</li>
</ol>

</section>`,

    textZh: `<section class="policy">
    <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">自驾车租赁政策</h1>
  
  <h2>费用包含</h2>
  <ol>
    <li>交通工具（汽车/摩托车）</li>
  </ol>

  <h2 style="margin-top:8px">费用不包含</h2>
  <ol>
    <li>司机</li>
    <li>燃油</li>
    <li>市内停车费，过路费</li>
    <li>个人开支</li>
  </ol>

  <h2 style="margin-top:8px">价格</h2>
  <ol>
    <li>新会员享受5%折扣</li>
    <li>Wirasana Sanur办公室免费车辆交付和归还</li>
    <li>机场/库塔/雷吉安/金巴兰/水明漾/登巴萨的车辆交付/归还费：<strong>IDR 100,000</strong></li>
    <li>乌鲁瓦图/仓古/佩雷雷南/乌布/吉安雅/努沙杜瓦/贝诺瓦的车辆交付/归还费：<strong>IDR 150,000</strong></li>
    <li>塔巴南/八丹拜/金塔马尼的车辆交付/归还费：<strong>IDR 300,000</strong></li>
    <li>阿梅德/图兰奔/内加拉/罗威那的车辆交付/归还费：<strong>IDR 450,000</strong></li>
    <li>国定假日、周末和节假日价格不同</li>
    <li>旅游司机租赁费用：
      <ul>
        <li>IDR 300,000 / 12小时</li>
        <li>IDR 250,000 / 6小时（仅司机）</li>
      </ul>
    </li>
    <li>最新车型保证：<strong>IDR 75,000/天</strong></li>
    <li>柴油车保证：<strong>IDR 75,000/天</strong></li>
    <li>车辆婚礼鲜花装饰请求：<strong>IDR 500,000</strong></li>
    <li>旅游附加司机：
      <ul>
        <li>IDR 300,000 / 12小时</li>
        <li>IDR 250,000 / 6小时（仅司机）</li>
      </ul>
    </li>
  </ol>

  <h2 style="margin-top:8px">不包含</h2>
  <ul>
    <li>餐食补贴</li>
    <li>加班费</li>
    <li>前往地点的交通</li>
    <li>停车费、过路费和旅游税</li>
    <li>住宿</li>
    <li>司机小费</li>
    <li>个人开支</li>
  </ul>

  <h2 style="margin-top:8px">加班费/小时</h2>
  <p><em>（超过2小时的额外租赁时间按1个租赁日计算）</em></p>
  <ul>
    <li><strong>IDR 10,000/小时</strong>: Vario, Scoopy</li>
    <li><strong>IDR 20,000/小时</strong>: X Max, N Max, PCX</li>
    <li><strong>IDR 50,000/小时</strong>: Agya, Calya, Avanza, Xenia, Yaris, Vespa</li>
    <li><strong>IDR 65,000/小时</strong>: Expander, Ertiga, Mobilio, Terios, Raize, Rush</li>
    <li><strong>IDR 75,000/小时</strong>: Innova, Reborn, Altis, Vios, Jazz, Veloz</li>
    <li><strong>IDR 100,000/小时</strong>: Fortuner, Pajero, Camry, Alphard</li>
    <li><strong>IDR 200,000/小时</strong>: Hiace</li>
    <li><strong>IDR 300,000/小时</strong>: Alphard Transformer</li>
  </ul>

  <h2 style="margin-top:8px">车辆租赁延期和重新安排</h2>
  <ol>
    <li>车辆仅限巴厘岛地区使用。</li>
    <li>如需延长车辆租赁超过2次，请到Wirasana Rent A Car Denpasar办公室（Jl. Bypass Ngurah Rai No. 162, Sanur Kaja, South Denpasar）核实确认。</li>
    <li>取车/还车地点变更如未在预订时间前<strong>24小时</strong>通知，则无法确认（避免操作错误）。</li>
    <li>取车/还车日期/时间变更将收取<strong>IDR 100,000</strong>（最多2次）。</li>
    <li>租赁车辆不得由签署租赁合同以外的租车人转让/使用。（如被滥用作为证据，将收取日租费）。</li>
    <li>如有多个司机，将收取<strong>IDR 50,000/身份证/天</strong>的额外费用。</li>
  </ol>

  <h2 style="margin-top:8px">损坏</h2>
  <ol>
    <li>因滥用/在非沥青路面上使用造成的轮胎损坏，将收取<strong>IDR 1,000,000/轮胎</strong>起。</li>
    <li>如车辆出现新划痕，将收取<strong>IDR 750,000/事故</strong>（价格不含自付额中的保险）。</li>
    <li>如途中燃油耗尽，市区内处理费为<strong>IDR 250,000</strong>，市区外从<strong>IDR 500,000</strong>起。</li>
    <li>请勿将车辆停放在树下/危及车辆位置的地点。</li>
    <li>如加错燃油，维修费为<strong>IDR 2,500,000</strong>。</li>
    <li>如果我们在租赁期间未收到需要车辆维修协助的信息，则未经批准/讨论，我们不接受任何维修店的报销。</li>
    <li>拖车费用和维修期间的租车费用不包含在自付额中。将根据您当时的位置收取<strong>IDR 1,000,000</strong>起的费用。</li>
    <li>如车辆出现问题，我们的机械师团队将尽力在最多4小时内赶上并为您提供帮助（取决于您当时的位置）。</li>
  </ol>

  <h2 style="margin-top:8px">丢失</h2>
  <ol>
    <li>丢失雨伞将收取<strong>IDR 100,000/把</strong>。</li>
    <li>丢失儿童汽车座椅将收取<strong>IDR 4,000,000/个</strong>。</li>
    <li>丢失车辆登记文件将收取<strong>IDR 1,500,000</strong>。</li>
    <li>丢失车辆登记文件复印件将收取<strong>IDR 5,000</strong>。</li>
    <li>丢失车牌将收取<strong>IDR 250,000</strong>起。</li>
    <li>丢失车钥匙将收取<strong>IDR 2,500,000</strong>起。</li>
  </ol>

  <h2 style="margin-top:8px">归还车辆</h2>
  <ol>
    <li>归还车辆时燃油不足将收取<strong>IDR 100,000/格</strong>或<strong>IDR 250,000/线</strong>。</li>
    <li>如归还车辆有榴莲/呕吐物/香烟/任何难闻气味/车辆座椅潮湿，将收取<strong>IDR 1,500,000</strong>起的费用。</li>
    <li>如归还车辆非常脏，将收取<strong>IDR 150,000</strong>起的清洁费。</li>
    <li>如车辆早于承诺日程归还（未在3天内提前确认或非紧急原因），仍视为按日程完成。剩余租期不可退款/转让至其他日期，并视为作废。</li>
  </ol>

  <h2 style="margin-top:8px">取消政策</h2>
  <ol>
    <li>当天取消 → <strong>付款不予退还</strong>。</li>
    <li>提前1天取消 → <strong>退款50%</strong>。</li>
    <li>提前7天取消 → <strong>退款100%</strong>。</li>
  </ol>
  <h2 style="margin-top:8px">自驾租车所需文件</h2>
<ol>
  <li>身份证/护照/KITAS（适用于外籍人士）</li>
  <li>驾驶执照 A/B1 或国际驾驶执照（有效）</li>
  <li>任意社交媒体账户</li>
  <li>酒店和回程机票预订</li>
  <li>两位紧急联系人：一位随行，一位不随行（姓名及关系）</li>
  <li>可退还押金 750,000 印尼盾（租期结束后 7 个工作日内退还，不包括公共假期）</li>
  <li>如果驾驶执照已过期，需支付押金 1,500,000 印尼盾</li>
</ol>

</section>`,
  },
  {
    type: "tour",
    textEn: `<section class="policy">
  <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">CAR WITH DRIVER POLICY</h1>

  <h2>Price Include</h2>
  <ol>
    <li>Driver</li>
    <li>Transport</li>
    <li>Airport parking within the city</li>
    <li>Fuel</li>
  </ol>

  <h2 style="margin-top:8px">Prices / Notes</h2>
  <ol>
    <li>5% discount for new members</li>
    <li>Price includes: Car, Driver, Fuel (within the City)</li>
    <li>
      Routes within the city: Denpasar, Kuta, Legian, Seminyak, Jimbaran, 
      Nusa Dua, Uluwatu, Kerobokan, Ubud Center
    </li>
    <li>Prices may vary on national holidays, weekends, and peak seasons</li>
    <li>Wedding flower decoration on car: <strong>IDR 500.000</strong></li>
  </ol>

  <h2 style="margin-top:8px">Out of Town Price</h2>
  <h3>Zone I (Bangli, Kintamani, Tabanan, Jatiluwih, Canggu, Pererenan, Gianyar outside Ubud Center) / Day</h3>
  <ul>
    <li><strong>IDR 200.000/day</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 300.000/day</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 400.000/day</strong>: Camry, Alphard Transformer</li>
  </ul>

  <h3>Zone II (Amed, Singaraja, Pelataran, Menjangan, Jembrana, Tulamben) / Day</h3>
  <ul>
    <li><strong>IDR 250.000/day</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 550.000/day</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 450.000/day</strong>: Camry, Alphard Transformer, Bus</li>
  </ul>

  <h2 style="margin-top:8px">Overtime Price / Hour</h2>
  <p>(Excess rental time of more than 2 hours is counted as 1 rental day)</p>
  <ul>
    <li><strong>IDR 100.000/hour</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 200.000/hour</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 300.000/hour</strong>: Camry, Alphard Transformer, Bus</li>
  </ul>

  <h2 style="margin-top:8px">Cancellation Policy and Return</h2>
  <ol>
    <li>Cancellation on the day → Payment is non-refundable</li>
    <li>Cancellation within H-1 period → 50% refund</li>
    <li>Cancellation within H-7 period → 100% refund</li>
    <li>
      If rental with driver ends earlier than committed schedule (without prior confirmation within 3 days, except emergencies), 
      the remaining days cannot be refunded/transferred and will be considered forfeited.
    </li>
  </ol>
</section>
`,
    textId: `<section class="policy">
  <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">KEBIJAKAN MOBIL DENGAN SUPIR</h1>

  <h2>Harga Termasuk</h2>
  <ol>
    <li>Sopir</li>
    <li>Transportasi</li>
    <li>Parkir bandara dalam kota</li>
    <li>Bahan bakar</li>
  </ol>

  <h2 style="margin-top:8px">Harga / Catatan</h2>
  <ol>
    <li>Diskon 5% untuk member baru</li>
    <li>Harga termasuk: Mobil, Sopir, Bahan Bakar (dalam Kota)</li>
    <li>
      Rute dalam kota: Denpasar, Kuta, Legian, Seminyak, Jimbaran, 
      Nusa Dua, Uluwatu, Kerobokan, Pusat Ubud
    </li>
    <li>Harga dapat berbeda pada hari libur nasional, akhir pekan, dan musim tinggi</li>
    <li>Dekorasi bunga pernikahan pada mobil: <strong>Rp 500.000</strong></li>
  </ol>

  <h2 style="margin-top:8px">Harga Luar Kota</h2>
  <h3>Zona I (Bangli, Kintamani, Tabanan, Jatiluwih, Canggu, Pererenan, Gianyar luar Pusat Ubud) / Hari</h3>
  <ul>
    <li><strong>Rp 200.000/hari</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>Rp 300.000/hari</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>Rp 400.000/hari</strong>: Camry, Alphard Transformer</li>
  </ul>

  <h3>Zona II (Amed, Singaraja, Pelataran, Menjangan, Jembrana, Tulamben) / Hari</h3>
  <ul>
    <li><strong>Rp 250.000/hari</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>Rp 550.000/hari</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>Rp 450.000/hari</strong>: Camry, Alphard Transformer, Bus</li>
  </ul>

  <h2 style="margin-top:8px">Harga Lembur / Jam</h2>
  <p>(Kelebihan waktu sewa lebih dari 2 jam dihitung sebagai 1 hari sewa)</p>
  <ul>
    <li><strong>Rp 100.000/jam</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>Rp 200.000/jam</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>Rp 300.000/jam</strong>: Camry, Alphard Transformer, Bus</li>
  </ul>

  <h2 style="margin-top:8px">Kebijakan Pembatalan dan Pengembalian</h2>
  <ol>
    <li>Pembatalan di hari-H → Pembayaran tidak dapat dikembalikan</li>
    <li>Pembatalan dalam periode H-1 → Pengembalian 50%</li>
    <li>Pembatalan dalam periode H-7 → Pengembalian 100%</li>
    <li>
      Jika sewa dengan sopir berakhir lebih awal dari jadwal yang dijanjikan (tanpa konfirmasi sebelumnya dalam 3 hari, kecuali darurat), 
      sisa hari tidak dapat dikembalikan/dipindahkan dan akan dianggap hangus.
    </li>
  </ol>
</section>
`,
    textDe: `<section class="policy">
  <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">RICHTLINIEN FÜR MIETWAGEN MIT FAHRER</h1>

  <h2>Im Preis inbegriffen</h2>
  <ol>
    <li>Fahrer</li>
    <li>Transport</li>
    <li>Flughafenparkplatz innerhalb der Stadt</li>
    <li>Kraftstoff</li>
  </ol>

  <h2 style="margin-top:8px">Preise / Hinweise</h2>
  <ol>
    <li>5% Rabatt für neue Mitglieder</li>
    <li>Preis inklusive: Auto, Fahrer, Kraftstoff (innerhalb der Stadt)</li>
    <li>
      Routen innerhalb der Stadt: Denpasar, Kuta, Legian, Seminyak, Jimbaran, 
      Nusa Dua, Uluwatu, Kerobokan, Ubud Zentrum
    </li>
    <li>Preise können an nationalen Feiertagen, Wochenenden und in der Hochsaison variieren</li>
    <li>Hochzeitsblumendekoration am Auto: <strong>IDR 500.000</strong></li>
  </ol>

  <h2 style="margin-top:8px">Preis außerhalb der Stadt</h2>
  <h3>Zone I (Bangli, Kintamani, Tabanan, Jatiluwih, Canggu, Pererenan, Gianyar außerhalb Ubud Zentrum) / Tag</h3>
  <ul>
    <li><strong>IDR 200.000/Tag</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 300.000/Tag</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 400.000/Tag</strong>: Camry, Alphard Transformer</li>
  </ul>

  <h3>Zone II (Amed, Singaraja, Pelataran, Menjangan, Jembrana, Tulamben) / Tag</h3>
  <ul>
    <li><strong>IDR 250.000/Tag</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 550.000/Tag</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 450.000/Tag</strong>: Camry, Alphard Transformer, Bus</li>
  </ul>

  <h2 style="margin-top:8px">Überstundenpreis / Stunde</h2>
  <p>(Überschüssige Mietzeit von mehr als 2 Stunden wird als 1 Miettag gezählt)</p>
  <ul>
    <li><strong>IDR 100.000/Stunde</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 200.000/Stunde</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 300.000/Stunde</strong>: Camry, Alphard Transformer, Bus</li>
  </ul>

  <h2 style="margin-top:8px">Stornierungsbedingungen und Rückgabe</h2>
  <ol>
    <li>Stornierung am Tag → Zahlung ist nicht erstattungsfähig</li>
    <li>Stornierung innerhalb der H-1-Periode → 50% Rückerstattung</li>
    <li>Stornierung innerhalb der H-7-Periode → 100% Rückerstattung</li>
    <li>
      Wenn die Miete mit Fahrer früher endet als der vereinbarte Zeitplan (ohne vorherige Bestätigung innerhalb von 3 Tagen, außer Notfällen), 
      können die verbleibenden Tage nicht erstattet/übertragen werden und gelten als verfallen.
    </li>
  </ol>
</section>
`,
    textFr: `<section class="policy">
  <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">POLITIQUE DE VOITURE AVEC CHAUFFEUR</h1>

  <h2>Prix Inclus</h2>
  <ol>
    <li>Chauffeur</li>
    <li>Transport</li>
    <li>Stationnement d'aéroport en ville</li>
    <li>Carburant</li>
  </ol>

  <h2 style="margin-top:8px">Prix / Notes</h2>
  <ol>
    <li>5% de réduction pour les nouveaux membres</li>
    <li>Prix inclus: Voiture, Chauffeur, Carburant (en ville)</li>
    <li>
      Itinéraires en ville: Denpasar, Kuta, Legian, Seminyak, Jimbaran, 
      Nusa Dua, Uluwatu, Kerobokan, Centre d'Ubud
    </li>
    <li>Les prix peuvent varier les jours fériés nationaux, week-ends et haute saison</li>
    <li>Décoration florale de mariage sur la voiture: <strong>IDR 500.000</strong></li>
  </ol>

  <h2 style="margin-top:8px">Prix Hors Ville</h2>
  <h3>Zone I (Bangli, Kintamani, Tabanan, Jatiluwih, Canggu, Pererenan, Gianyar hors Centre d'Ubud) / Jour</h3>
  <ul>
    <li><strong>IDR 200.000/jour</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 300.000/jour</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 400.000/jour</strong>: Camry, Alphard Transformer</li>
  </ul>

  <h3>Zone II (Amed, Singaraja, Pelataran, Menjangan, Jembrana, Tulamben) / Jour</h3>
  <ul>
    <li><strong>IDR 250.000/jour</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 550.000/jour</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 450.000/jour</strong>: Camry, Alphard Transformer, Bus</li>
  </ul>

  <h2 style="margin-top:8px">Prix Heures Supplémentaires / Heure</h2>
  <p>(Excédent de temps de location de plus de 2 heures est compté comme 1 jour de location)</p>
  <ul>
    <li><strong>IDR 100.000/heure</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 200.000/heure</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 300.000/heure</strong>: Camry, Alphard Transformer, Bus</li>
  </ul>

  <h2 style="margin-top:8px">Politique d'Annulation et Retour</h2>
  <ol>
    <li>Annulation le jour J → Paiement non remboursable</li>
    <li>Annulation dans la période H-1 → Remboursement à 50%</li>
    <li>Annulation dans la période H-7 → Remboursement à 100%</li>
    <li>
      Si la location avec chauffeur se termine plus tôt que prévu (sans confirmation préalable dans les 3 jours, sauf urgences), 
      les jours restants ne peuvent être remboursés/transférés et seront considérés comme perdus.
    </li>
  </ol>
</section>
`,
    textKo: `<section class="policy">
  <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">기사 포함 차량 렌트 정책</h1>

  <h2>포함 사항</h2>
  <ol>
    <li>기사</li>
    <li>교통수단</li>
    <li>시내 공항 주차</li>
    <li>연료</li>
  </ol>

  <h2 style="margin-top:8px">가격 / 참고사항</h2>
  <ol>
    <li>신규 회원 5% 할인</li>
    <li>가격 포함: 차량, 기사, 연료 (시내)</li>
    <li>
      시내 노선: 덴파사르, 쿠타, 레기안, 세미냑, 짐바란, 
      누사두아, 울루와투, 케로보칸, 우붓 중심가
    </li>
    <li>국경일, 주말, 성수기에는 가격이 변동될 수 있음</li>
    <li>차량 웨딩 플라워 데코레이션: <strong>IDR 500.000</strong></li>
  </ol>

  <h2 style="margin-top:8px">시외 요금</h2>
  <h3>구역 I (방글리, 킨타마니, 타바난, 자틀루위, 창구, 페레레난, 우붓 중심가 외 기안야르) / 일</h3>
  <ul>
    <li><strong>IDR 200.000/일</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 300.000/일</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 400.000/일</strong>: Camry, Alphard Transformer</li>
  </ul>

  <h3>구역 II (아메드, 싱아라자, 펠라타란, 멘장안, 젬브라나, 툴람벤) / 일</h3>
  <ul>
    <li><strong>IDR 250.000/일</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 550.000/일</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 450.000/일</strong>: Camry, Alphard Transformer, Bus</li>
  </ul>

  <h2 style="margin-top:8px">초과 시간 요금 / 시간</h2>
  <p>(2시간 초과 사용 시 1일 렌트로 계산)</p>
  <ul>
    <li><strong>IDR 100.000/시간</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 200.000/시간</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 300.000/시간</strong>: Camry, Alphard Transformer, Bus</li>
  </ul>

  <h2 style="margin-top:8px">취소 정책 및 반환</h2>
  <ol>
    <li>당일 취소 → 결제금 환불 불가</li>
    <li>D-1 기간 내 취소 → 50% 환불</li>
    <li>D-7 기간 내 취소 → 100% 환불</li>
    <li>
      기사 포함 렌트가 약정 일정보다 일찍 종료되는 경우 (3일 내 사전 확인 없거나 비상 사유가 아닌 경우),
      남은 기간은 환불/이전되지 않으며 소멸된 것으로 간주됩니다.
    </li>
  </ol>
</section>
`,
    textNl: `<section class="policy">
  <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">BELEID AUTO MET CHAUFFEUR</h1>

  <h2>Prijs Inclusief</h2>
  <ol>
    <li>Chauffeur</li>
    <li>Vervoer</li>
    <li>Luchthavenparkeren binnen de stad</li>
    <li>Brandstof</li>
  </ol>

  <h2 style="margin-top:8px">Prijzen / Opmerkingen</h2>
  <ol>
    <li>5% korting voor nieuwe leden</li>
    <li>Prijs inclusief: Auto, Chauffeur, Brandstof (binnen de stad)</li>
    <li>
      Routes binnen de stad: Denpasar, Kuta, Legian, Seminyak, Jimbaran, 
      Nusa Dua, Uluwatu, Kerobokan, Ubud Centrum
    </li>
    <li>Prijzen kunnen variëren op nationale feestdagen, weekenden en hoogseizoen</li>
    <li>Trouwbloemdecoratie op auto: <strong>IDR 500.000</strong></li>
  </ol>

  <h2 style="margin-top:8px">Buitenstad Prijs</h2>
  <h3>Zone I (Bangli, Kintamani, Tabanan, Jatiluwih, Canggu, Pererenan, Gianyar buiten Ubud Centrum) / Dag</h3>
  <ul>
    <li><strong>IDR 200.000/dag</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 300.000/dag</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 400.000/dag</strong>: Camry, Alphard Transformer</li>
  </ul>

  <h3>Zone II (Amed, Singaraja, Pelataran, Menjangan, Jembrana, Tulamben) / Dag</h3>
  <ul>
    <li><strong>IDR 250.000/dag</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 550.000/dag</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 450.000/dag</strong>: Camry, Alphard Transformer, Bus</li>
  </ul>

  <h2 style="margin-top:8px">Overwerk Prijs / Uur</h2>
  <p>(Overtollige huurtijd van meer dan 2 uur telt als 1 huurdag)</p>
  <ul>
    <li><strong>IDR 100.000/uur</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 200.000/uur</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 300.000/uur</strong>: Camry, Alphard Transformer, Bus</li>
  </ul>

  <h2 style="margin-top:8px">Annuleringsbeleid en Retour</h2>
  <ol>
    <li>Annulering op de dag → Betaling is niet restitueerbaar</li>
    <li>Annulering binnen H-1 periode → 50% restitutie</li>
    <li>Annulering binnen H-7 periode → 100% restitutie</li>
    <li>
      Als verhuur met chauffeur eerder eindigt dan het toegezegde schema (zonder voorafgaande bevestiging binnen 3 dagen, behalve noodgevallen), 
      kunnen de resterende dagen niet worden terugbetaald/overgedragen en worden als vervallen beschouwd.
    </li>
  </ol>
</section>
`,
    textRu: `<section class="policy">
  <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">ПОЛИТИКА АРЕНДЫ АВТОМОБИЛЯ С ВОДИТЕЛЕМ</h1>

  <h2>Включено в стоимость</h2>
  <ol>
    <li>Водитель</li>
    <li>Транспорт</li>
    <li>Парковка в аэропорту в пределах города</li>
    <li>Топливо</li>
  </ol>

  <h2 style="margin-top:8px">Цены / Примечания</h2>
  <ol>
    <li>5% скидка для новых участников</li>
    <li>Цена включает: Автомобиль, Водитель, Топливо (в пределах города)</li>
    <li>
      Маршруты в пределах города: Денпасар, Кута, Легиан, Семиньяк, Джимбаран, 
      Нуса-Дуа, Улувату, Керобокан, Центр Убуда
    </li>
    <li>Цены могут меняться в национальные праздники, выходные и пиковый сезон</li>
    <li>Свадебное цветочное украшение на автомобиле: <strong>IDR 500.000</strong></li>
  </ol>

  <h2 style="margin-top:8px">Стоимость за городом</h2>
  <h3>Зона I (Бангли, Кинтамани, Табанан, Джатилувих, Канггу, Переренан, Гианьяр за пределами Центра Убуда) / День</h3>
  <ul>
    <li><strong>IDR 200.000/день</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 300.000/день</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 400.000/день</strong>: Camry, Alphard Transformer</li>
  </ul>

  <h3>Зона II (Амед, Сингараджа, Пелатаран, Менджанган, Джембрана, Туламбен) / День</h3>
  <ul>
    <li><strong>IDR 250.000/день</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 550.000/день</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 450.000/день</strong>: Camry, Alphard Transformer, Автобус</li>
  </ul>

  <h2 style="margin-top:8px">Стоимость сверхурочного времени / Час</h2>
  <p>(Превышение времени аренды более 2 часов считается за 1 день аренды)</p>
  <ul>
    <li><strong>IDR 100.000/час</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 200.000/час</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 300.000/час</strong>: Camry, Alphard Transformer, Автобус</li>
  </ul>

  <h2 style="margin-top:8px">Политика отмены и возврата</h2>
  <ol>
    <li>Отмена в день → Оплата не возвращается</li>
    <li>Отмена в течение периода за 1 день → Возврат 50%</li>
    <li>Отмена в течение периода за 7 дней → Возврат 100%</li>
    <li>
      Если аренда с водителем заканчивается раньше оговоренного срока (без предварительного подтверждения в течение 3 дней, кроме чрезвычайных ситуаций), 
      оставшиеся дни не подлежат возврату/переводу и считаются утраченными.
    </li>
  </ol>
</section>
`,
    textZh: `<section class="policy">
  <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">带司机车辆租赁政策</h1>

  <h2>费用包含</h2>
  <ol>
    <li>司机</li>
    <li>交通工具</li>
    <li>市内机场停车</li>
    <li>燃油</li>
  </ol>

  <h2 style="margin-top:8px">价格 / 备注</h2>
  <ol>
    <li>新会员享受5%折扣</li>
    <li>价格包含：汽车、司机、燃油（市内）</li>
    <li>
      市内路线：登巴萨、库塔、雷吉安、水明漾、金巴兰、
      努沙杜瓦、乌鲁瓦图、克罗博坎、乌布中心
    </li>
    <li>国定假日、周末和旺季价格可能变动</li>
    <li>车辆婚礼鲜花装饰：<strong>IDR 500.000</strong></li>
  </ol>

  <h2 style="margin-top:8px">市外价格</h2>
  <h3>区域一（邦利、金塔马尼、塔巴南、贾蒂卢维、仓古、佩雷雷南、乌布中心外的吉安雅）/ 天</h3>
  <ul>
    <li><strong>IDR 200.000/天</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 300.000/天</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 400.000/天</strong>: Camry, Alphard Transformer</li>
  </ul>

  <h3>区域二（阿梅德、辛加拉贾、佩拉塔兰、门姜安、珍布拉纳、图兰奔）/ 天</h3>
  <ul>
    <li><strong>IDR 250.000/天</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 550.000/天</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 450.000/天</strong>: Camry, Alphard Transformer, 巴士</li>
  </ul>

  <h2 style="margin-top:8px">加班费 / 小时</h2>
  <p>（超过2小时的额外租赁时间按1个租赁日计算）</p>
  <ul>
    <li><strong>IDR 100.000/小时</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
    <li><strong>IDR 200.000/小时</strong>: Alphard, Hiace, Fortuner, Pajero</li>
    <li><strong>IDR 300.000/小时</strong>: Camry, Alphard Transformer, 巴士</li>
  </ul>

  <h2 style="margin-top:8px">取消政策和归还</h2>
  <ol>
    <li>当天取消 → 付款不予退还</li>
    <li>提前1天取消 → 退款50%</li>
    <li>提前7天取消 → 退款100%</li>
    <li>
      如果带司机租赁早于承诺日程结束（未在3天内提前确认，紧急情况除外），
      剩余天数不可退款/转让，并视为作废。
    </li>
  </ol>
</section>
`,
  },
  {
    type: "transfer_service",
    textEn: `<section class="policy">
    <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">AIRPORT TRANSFER POLICY</h1>
  <h2>Price Include</h2>
  <ol>
    <li>Driver</li>
    <li>Transport</li>
    <li>Airport parking within the city</li>
    <li>Fuel</li>
  </ol>

  <h2 style="margin-top:8px">Prices / Notes</h2>
  <ol>
    <li>Please confirm that you have boarded and landed at Ngurah Rai International Airport.</li>
    <li>
      The pick-up point is at the Solaria Restaurant at the very end. If you want to request another pick-up point around the airport area, you can contact the Wirasana Rent a Car WhatsApp group.
    </li>
    <li>Detailed information about drivers who will be in charge will be provided on the day.</li>
    <li>Voucher is only valid for one non-stop pick-up / one-way drop only.</li>
    <li>
      Additional stops for lunch or meals at a restaurant, or other stops, will incur an additional fee of <strong>IDR 100,000/hour</strong> (must be on the same route to your destination). Otherwise the charge would be counted as a 6-hour or 12-hour booking charge.
    </li>
    <li>
      It is not permitted to eat and drink in the vehicle which can cause spills/leave a smell. A cleaning/compensation fee starting from <strong>IDR 1,500,000</strong> will be charged.
    </li>
    <li>
      Drivers will wait free of charge for:
      <ul>
        <li>Domestic flights: up to 45 minutes from the booking time</li>
        <li>International flights: up to 2 hours from the booking time</li>
      </ul>
      If waiting time exceeds the free allowance, additional fees apply as below:
      <ul>
        <li><strong>IDR 100.000/hour</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
        <li><strong>IDR 200.000/hour</strong>: Alphard, Hiace, Fortuner, Pajero</li>
        <li><strong>IDR 300.000/hour</strong>: Camry, Alphard Transformer, Bus</li>
      </ul>
    </li>
  </ol>

  <h2 style="margin-top:8px">Reschedule</h2>
  <ol>
    <li>
      Reschedule of location, time, or pick-up destination cannot be confirmed if notification is given less than <strong>1 x 24 hours</strong> before the scheduled time (to avoid operational setup errors), unless driver or vehicle allotment still allows it.
    </li>
    <li>Rescheduling the pick-up location will incur additional fees according to location starting from <strong>IDR 100,000</strong> (maximum 2 changes).</li>
    <li>
      If there is a delay from the airline, please attach proof. Our drivers will try to arrive according to the latest schedule and we will confirm (at no cost). However, the type of vehicle used will follow availability according to the latest schedule.
    </li>
  </ol>

  <h2 style="margin-top:8px">Cancellation Policy</h2>
  <ol>
    <li>Cancellation on the day: the payment is non-refundable.</li>
    <li>Cancellation within H-1 period: 50% of the payment will be returned.</li>
    <li>Cancellation within H-7 period: 100% of the payment will be returned.</li>
  </ol>
</section>
`,
    textId: `<section class="policy">
    <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">KEBIJAKAN TRANSFER BANDARA</h1>
  <h2>Harga Termasuk</h2>
  <ol>
    <li>Sopir</li>
    <li>Transportasi</li>
    <li>Parkir bandara dalam kota</li>
    <li>Bahan bakar</li>
  </ol>

  <h2 style="margin-top:8px">Harga / Catatan</h2>
  <ol>
    <li>Harap konfirmasi bahwa Anda telah naik dan mendarat di Bandara Internasional Ngurah Rai.</li>
    <li>
      Titik penjemputan berada di Restoran Solaria di ujung paling akhir. Jika ingin meminta titik penjemputan lain di sekitar area bandara, dapat menghubungi grup WhatsApp Wirasana Rent a Car.
    </li>
    <li>Informasi detail tentang sopir yang akan bertugas akan diberikan pada hari-H.</li>
    <li>Voucher hanya berlaku untuk satu kali penjemputan tanpa henti / satu kali pengantaran satu arah.</li>
    <li>
      Tambahan berhenti untuk makan siang atau makan di restoran, atau berhenti lainnya, akan dikenakan biaya tambahan <strong>Rp 100.000/jam</strong> (harus berada di rute yang sama ke tujuan Anda). Jika tidak, biaya akan dihitung sebagai biaya pemesanan 6 jam atau 10 jam.
    </li>
    <li>
      Tidak diizinkan makan dan minum di dalam kendaraan yang dapat menyebabkan tumpahan/meninggalkan bau. Biaya kebersihan/kompensasi mulai dari <strong>Rp 1.500.000</strong> akan dikenakan.
    </li>
    <li>
      Sopir akan menunggu gratis untuk:
      <ul>
        <li>Penerbangan domestik: hingga 45 menit dari waktu pemesanan</li>
        <li>Penerbangan internasional: hingga 2 jam dari waktu pemesanan</li>
      </ul>
      Jika waktu tunggu melebihi batas gratis, biaya tambahan berlaku sebagai berikut:
      <ul>
        <li><strong>Rp 100.000/jam</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
        <li><strong>Rp 200.000/jam</strong>: Alphard, Hiace, Fortuner, Pajero</li>
        <li><strong>Rp 300.000/jam</strong>: Camry, Alphard Transformer, Bus</li>
      </ul>
    </li>
  </ol>

  <h2 style="margin-top:8px">Penjadwalan Ulang</h2>
  <ol>
    <li>
      Penjadwalan ulang lokasi, waktu, atau tujuan penjemputan tidak dapat dikonfirmasi jika pemberitahuan diberikan kurang dari <strong>1 x 24 jam</strong> sebelum waktu yang dijadwalkan (untuk menghindari kesalahan setup operasional), kecuali alokasi sopir atau kendaraan masih memungkinkan.
    </li>
    <li>Penjadwalan ulang lokasi penjemputan akan dikenakan biaya tambahan sesuai lokasi mulai dari <strong>Rp 100.000</strong> (maksimal 2 perubahan).</li>
    <li>
      Jika ada penundaan dari maskapai, harap lampirkan bukti. Sopir kami akan berusaha tiba sesuai jadwal terbaru dan kami akan konfirmasi (tanpa biaya). Namun, jenis kendaraan yang digunakan akan mengikuti ketersediaan sesuai jadwal terbaru.
    </li>
  </ol>

  <h2 style="margin-top:8px">Kebijakan Pembatalan</h2>
  <ol>
    <li>Pembatalan di hari-H: pembayaran tidak dapat dikembalikan.</li>
    <li>Pembatalan dalam periode H-1: 50% dari pembayaran akan dikembalikan.</li>
    <li>Pembatalan dalam periode H-7: 100% dari pembayaran akan dikembalikan.</li>
  </ol>
</section>
`,
    textDe: `<section class="policy">
    <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">FLUGHAFEN-TRANSFER-RICHTLINIEN</h1>
  <h2>Im Preis inbegriffen</h2>
  <ol>
    <li>Fahrer</li>
    <li>Transport</li>
    <li>Flughafenparkplatz innerhalb der Stadt</li>
    <li>Kraftstoff</li>
  </ol>

  <h2 style="margin-top:8px">Preise / Hinweise</h2>
  <ol>
    <li>Bitte bestätigen Sie, dass Sie am Ngurah Rai International Airport gelandet sind.</li>
    <li>
      Der Abholpunkt befindet sich im Solaria Restaurant am Ende. Wenn Sie einen anderen Abholpunkt im Flughafenbereich wünschen, können Sie die Wirasana Rent a Car WhatsApp-Gruppe kontaktieren.
    </li>
    <li>Detaillierte Informationen über die zuständigen Fahrer werden am Tag selbst bereitgestellt.</li>
    <li>Der Gutschein ist nur für eine non-stop Abholung / einfache Fahrt gültig.</li>
    <li>
      Zusätzliche Stopps für Mittagessen oder Mahlzeiten in einem Restaurant oder andere Stopps werden mit einer zusätzlichen Gebühr von <strong>IDR 100.000/Stunde</strong> berechnet (muss auf derselben Route zu Ihrem Ziel sein). Andernfalls wird die Gebühr als 6-Stunden- oder 12-Stunden-Buchungsgebühr berechnet.
    </li>
    <li>
      Essen und Trinken im Fahrzeug, die Verschüttungen/Gerüche verursachen können, sind nicht erlaubt. Eine Reinigungs-/Entschädigungsgebühr ab <strong>IDR 1.500.000</strong> wird berechnet.
    </li>
    <li>
      Fahrer warten kostenlos für:
      <ul>
        <li>Inlandsflüge: bis zu 45 Minuten ab Buchungszeit</li>
        <li>Internationale Flüge: bis zu 2 Stunden ab Buchungszeit</li>
      </ul>
      Wenn die Wartezeit das kostenlose Kontingent überschreitet, gelten folgende zusätzliche Gebühren:
      <ul>
        <li><strong>IDR 100.000/Stunde</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
        <li><strong>IDR 200.000/Stunde</strong>: Alphard, Hiace, Fortuner, Pajero</li>
        <li><strong>IDR 300.000/Stunde</strong>: Camry, Alphard Transformer, Bus</li>
      </ul>
    </li>
  </ol>

  <h2 style="margin-top:8px">Neuplanung</h2>
  <ol>
    <li>
      Die Neuplanung von Ort, Zeit oder Abholziel kann nicht bestätigt werden, wenn die Benachrichtigung weniger als <strong>1 x 24 Stunden</strong> vor der geplanten Zeit erfolgt (um Betriebsfehler zu vermeiden), es sei denn, die Fahrer- oder Fahrzeugzuteilung ermöglicht dies noch.
    </li>
    <li>Die Neuplanung des Abholorts führt zu zusätzlichen Gebühren je nach Standort ab <strong>IDR 100.000</strong> (maximal 2 Änderungen).</li>
    <li>
      Bei Verspätungen der Fluggesellschaft legen Sie bitte einen Nachweis vor. Unsere Fahrer werden versuchen, gemäß dem neuesten Zeitplan anzukommen, und wir werden bestätigen (kostenlos). Allerdings richtet sich der Fahrzeugtyp nach der Verfügbarkeit gemäß dem neuesten Zeitplan.
    </li>
  </ol>

  <h2 style="margin-top:8px">Stornierungsbedingungen</h2>
  <ol>
    <li>Stornierung am Tag: Die Zahlung ist nicht erstattungsfähig.</li>
    <li>Stornierung innerhalb der H-1-Periode: 50% der Zahlung werden zurückerstattet.</li>
    <li>Stornierung innerhalb der H-7-Periode: 100% der Zahlung werden zurückerstattet.</li>
  </ol>
</section>
`,
    textFr: `<section class="policy">
    <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">POLITIQUE DE TRANSFERT AÉROPORT</h1>
  <h2>Prix Inclus</h2>
  <ol>
    <li>Chauffeur</li>
    <li>Transport</li>
    <li>Stationnement d'aéroport en ville</li>
    <li>Carburant</li>
  </ol>

  <h2 style="margin-top:8px">Prix / Notes</h2>
  <ol>
    <li>Veuillez confirmer que vous avez embarqué et atterri à l'Aéroport International Ngurah Rai.</li>
    <li>
      Le point de prise en charge se trouve au restaurant Solaria à l'extrémité. Si vous souhaitez demander un autre point de prise en charge autour de l'aéroport, vous pouvez contacter le groupe WhatsApp de Wirasana Rent a Car.
    </li>
    <li>Des informations détaillées sur les chauffeurs responsables seront fournies le jour même.</li>
    <li>Le bon n'est valable que pour une prise en charge sans escale / un trajet simple uniquement.</li>
    <li>
      Les arrêts supplémentaires pour le déjeuner ou les repas au restaurant, ou autres arrêts, entraîneront des frais supplémentaires de <strong>IDR 100.000/heure</strong> (doit être sur le même itinéraire que votre destination). Sinon, les frais seront comptés comme une réservation de 6 heures ou 12 heures.
    </li>
    <li>
      Il n'est pas permis de manger et boire dans le véhicule pouvant causer des déversements/laisser une odeur. Des frais de nettoyage/compensation à partir de <strong>IDR 1.500.000</strong> seront facturés.
    </li>
    <li>
      Les chauffeurs attendront gratuitement pour:
      <ul>
        <li>Vols domestiques: jusqu'à 45 minutes à partir de l'heure de réservation</li>
        <li>Vols internationaux: jusqu'à 2 heures à partir de l'heure de réservation</li>
      </ul>
      Si le temps d'attente dépasse la limite gratuite, des frais supplémentaires s'appliquent comme suit:
      <ul>
        <li><strong>IDR 100.000/heure</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
        <li><strong>IDR 200.000/heure</strong>: Alphard, Hiace, Fortuner, Pajero</li>
        <li><strong>IDR 300.000/heure</strong>: Camry, Alphard Transformer, Bus</li>
      </ul>
    </li>
  </ol>

  <h2 style="margin-top:8px">Replanification</h2>
  <ol>
    <li>
      La replanification du lieu, de l'heure ou de la destination de prise en charge ne peut être confirmée si la notification est donnée moins de <strong>1 x 24 heures</strong> avant l'heure prévue (pour éviter les erreurs opérationnelles), sauf si l'allocation de chauffeur ou de véhicule le permet encore.
    </li>
    <li>La replanification du lieu de prise en charge entraînera des frais supplémentaires selon le lieu à partir de <strong>IDR 100.000</strong> (maximum 2 changements).</li>
    <li>
      En cas de retard de la compagnie aérienne, veuillez joindre une preuve. Nos chauffeurs essaieront d'arriver selon le dernier horaire et nous confirmerons (sans frais). Cependant, le type de véhicule utilisé suivra la disponibilité selon le dernier horaire.
    </li>
  </ol>

  <h2 style="margin-top:8px">Politique d'Annulation</h2>
  <ol>
    <li>Annulation le jour J: le paiement est non remboursable.</li>
    <li>Annulation dans la période H-1: 50% du paiement sera retourné.</li>
    <li>Annulation dans la période H-7: 100% du paiement sera retourné.</li>
  </ol>
</section>
`,
    textKo: `<section class="policy">
    <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">공항 픽업 서비스 정책</h1>
  <h2>포함 사항</h2>
  <ol>
    <li>기사</li>
    <li>교통수단</li>
    <li>시내 공항 주차</li>
    <li>연료</li>
  </ol>

  <h2 style="margin-top:8px">가격 / 참고사항</h2>
  <ol>
    <li>응우라라이 국제공항에 탑승 및 도착했음을 확인해 주십시오.</li>
    <li>
      픽업 지점은 가장 끝에 있는 솔라리아 레스토랑입니다. 공항 주변 다른 픽업 지점을 요청하려면 Wirasana Rent a Car WhatsApp 그룹으로 연락하실 수 있습니다.
    </li>
    <li>담당 기사에 대한 상세 정보는 당일에 제공됩니다.</li>
    <li>바우처는 무정차 픽업 1회 / 편도 이동만 유효합니다.</li>
    <li>
      점심 식사나 레스토랑 식사, 또는 기타 정차를 위한 추가 정류는 <strong>IDR 100,000/시간</strong>의 추가 요금이 부과됩니다 (목적지까지 동일한 경로상이어야 함). 그렇지 않으면 6시간 또는 12시간 예약 요금으로 계산됩니다.
    </li>
    <li>
      차량 내에서 음식물을 흘리거나 냄새를 남길 수 있는 음식 및 음료 섭취는 허용되지 않습니다. <strong>IDR 1,500,000</strong>부터 시작하는 청소/보상 비용이 부과됩니다.
    </li>
    <li>
      기사가 무료로 대기하는 시간:
      <ul>
        <li>국내선: 예약 시간으로부터 최대 45분</li>
        <li>국제선: 예약 시간으로부터 최대 2시간</li>
      </ul>
      무료 대기 시간을 초과할 경우 다음과 같은 추가 요금이 적용됩니다:
      <ul>
        <li><strong>IDR 100,000/시간</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
        <li><strong>IDR 200,000/시간</strong>: Alphard, Hiace, Fortuner, Pajero</li>
        <li><strong>IDR 300,000/시간</strong>: Camry, Alphard Transformer, 버스</li>
      </ul>
    </li>
  </ol>

  <h2 style="margin-top:8px">일정 변경</h2>
  <ol>
    <li>
      위치, 시간 또는 픽업 목적지 변경은 예정 시간 <strong>24시간 미만</strong>으로 통보 시 확인되지 않습니다 (운영 설정 오류 방지), 단 기사 또는 차량 할당이 여전히 허용하는 경우는 제외됩니다.
    </li>
    <li>픽업 위치 변경은 위치에 따라 <strong>IDR 100,000</strong>부터 추가 요금이 부과됩니다 (최대 2회 변경).</li>
    <li>
      항공사 지연이 있을 경우 증명서를 첨부해 주십시오. 당사 기사는 최신 일정에 따라 도착하려고 노력하며 확인해 드립니다 (무료). 그러나 사용되는 차량 유형은 최신 일정에 따른 가용성을 따릅니다.
    </li>
  </ol>

  <h2 style="margin-top:8px">취소 정책</h2>
  <ol>
    <li>당일 취소: 결제금은 환불되지 않습니다.</li>
    <li>D-1 기간 내 취소: 결제금의 50%가 반환됩니다.</li>
    <li>D-7 기간 내 취소: 결제금의 100%가 반환됩니다.</li>
  </ol>
</section>
`,
    textNl: `<section class="policy">
    <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">LUCHTHAVEN TRANSFER BELEID</h1>
  <h2>Prijs Inclusief</h2>
  <ol>
    <li>Chauffeur</li>
    <li>Vervoer</li>
    <li>Luchthavenparkeren binnen de stad</li>
    <li>Brandstof</li>
  </ol>

  <h2 style="margin-top:8px">Prijzen / Opmerkingen</h2>
  <ol>
    <li>Bevestig dat u bent ingestapt en geland op Ngurah Rai International Airport.</li>
    <li>
      Het ophaalpunt is bij het Solaria Restaurant helemaal aan het einde. Als u een ander ophaalpunt rond het vliegveld wilt aanvragen, kunt u contact opnemen met de Wirasana Rent a Car WhatsApp-groep.
    </li>
    <li>Gedetailleerde informatie over de chauffeurs die verantwoordelijk zijn, wordt op de dag zelf verstrekt.</li>
    <li>De voucher is alleen geldig voor één non-stop ophaling / enkele reis.</li>
    <li>
      Extra stops voor lunch of maaltijden in een restaurant, of andere stops, brengen extra kosten met zich mee van <strong>IDR 100.000/uur</strong> (moet op dezelfde route naar uw bestemming zijn). Anders worden de kosten berekend als een 6-uur of 12-uur boekingskosten.
    </li>
    <li>
      Het is niet toegestaan om te eten en drinken in het voertuig wat morsen/een geur kan veroorzaken. Een schoonmaak-/vergoedingskosten vanaf <strong>IDR 1.500.000</strong> wordt in rekening gebracht.
    </li>
    <li>
      Chauffeurs wachten gratis voor:
      <ul>
        <li>Binnenlandse vluchten: tot 45 minuten vanaf de boekingtijd</li>
        <li>Internationale vluchten: tot 2 uur vanaf de boekingtijd</li>
      </ul>
      Als de wachttijd de gratis toelage overschrijdt, zijn extra kosten van toepassing zoals hieronder:
      <ul>
        <li><strong>IDR 100.000/uur</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
        <li><strong>IDR 200.000/uur</strong>: Alphard, Hiace, Fortuner, Pajero</li>
        <li><strong>IDR 300.000/uur</strong>: Camry, Alphard Transformer, Bus</li>
      </ul>
    </li>
  </ol>

  <h2 style="margin-top:8px">Herplanning</h2>
  <ol>
    <li>
      Herplanning van locatie, tijd of ophaalbestemming kan niet worden bevestigd als melding minder dan <strong>1 x 24 uur</strong> voor de geplande tijd wordt gegeven (om operationele opzetfouten te voorkomen), tenzij chauffeur- of voertuigtoewijzing dit nog toestaat.
    </li>
    <li>Het herplannen van de ophaallocatie brengt extra kosten met zich mee volgens locatie vanaf <strong>IDR 100.000</strong> (maximaal 2 wijzigingen).</li>
    <li>
      Als er een vertraging is van de luchtvaartmaatschappij, voeg dan bewijs toe. Onze chauffeurs zullen proberen aan te komen volgens het laatste schema en wij zullen bevestigen (zonder kosten). Het type voertuig dat wordt gebruikt, volgt echter de beschikbaarheid volgens het laatste schema.
    </li>
  </ol>

  <h2 style="margin-top:8px">Annuleringsbeleid</h2>
  <ol>
    <li>Annulering op de dag: de betaling is niet restitueerbaar.</li>
    <li>Annulering binnen H-1 periode: 50% van de betaling wordt terugbetaald.</li>
    <li>Annulering binnen H-7 periode: 100% van de betaling wordt terugbetaald.</li>
  </ol>
</section>
`,
    textRu: `<section class="policy">
    <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">ПОЛИТИКА ТРАНСФЕРА ИЗ АЭРОПОРТА</h1>
  <h2>Включено в стоимость</h2>
  <ol>
    <li>Водитель</li>
    <li>Транспорт</li>
    <li>Парковка в аэропорту в пределах города</li>
    <li>Топливо</li>
  </ol>

  <h2 style="margin-top:8px">Цены / Примечания</h2>
  <ol>
    <li>Пожалуйста, подтвердите, что вы вылетели и приземлились в международном аэропорту Нгурах-Рай.</li>
    <li>
      Точка встречи находится в ресторане Solaria в самом конце. Если вы хотите запросить другую точку встречи вокруг аэропорта, вы можете связаться с группой WhatsApp Wirasana Rent a Car.
    </li>
    <li>Подробная информация о водителях, которые будут отвечать, будет предоставлена в день.</li>
    <li>Ваучер действителен только для одной встречи без остановок / одной поездки в одну сторону.</li>
    <li>
      Дополнительные остановки для обеда или еды в ресторане, или другие остановки, повлекут дополнительную плату в размере <strong>IDR 100.000/час</strong> (должны быть на том же маршруте к вашему месту назначения). В противном случае плата будет считаться как плата за бронирование на 6 часов или 12 часов.
    </li>
    <li>
      Не разрешается есть и пить в транспортном средстве, что может вызвать разливы/оставить запах. Плата за уборку/компенсацию от <strong>IDR 1.500.000</strong> будет взиматься.
    </li>
    <li>
      Водители будут ждать бесплатно:
      <ul>
        <li>Внутренние рейсы: до 45 минут от времени бронирования</li>
        <li>Международные рейсы: до 2 часов от времени бронирования</li>
      </ul>
      Если время ожидания превышает бесплатное пособие, применяются дополнительные сборы, как указано ниже:
      <ul>
        <li><strong>IDR 100.000/час</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
        <li><strong>IDR 200.000/час</strong>: Alphard, Hiace, Fortuner, Pajero</li>
        <li><strong>IDR 300.000/час</strong>: Camry, Alphard Transformer, Автобус</li>
      </ul>
    </li>
  </ol>

  <h2 style="margin-top:8px">Перенос</h2>
  <ol>
    <li>
      Перенос места, времени или места встречи не может быть подтвержден, если уведомление дано менее чем за <strong>1 x 24 часа</strong> до запланированного времени (чтобы избежать ошибок операционной настройки), если только распределение водителя или транспортного средства все еще позволяет это.
    </li>
    <li>Перенос места встречи повлечет дополнительные сборы в зависимости от местоположения от <strong>IDR 100.000</strong> (максимум 2 изменения).</li>
    <li>
      Если есть задержка от авиакомпании, приложите доказательства. Наши водители постараются прибыть согласно последнему расписанию, и мы подтвердим (без затрат). Однако тип используемого транспортного средства будет следовать доступности согласно последнему расписанию.
    </li>
  </ol>

  <h2 style="margin-top:8px">Политика отмены</h2>
  <ol>
    <li>Отмена в день: оплата не возвращается.</li>
    <li>Отмена в течение периода за 1 день: 50% оплаты будет возвращено.</li>
    <li>Отмена в течение периода за 7 дней: 100% оплаты будет возвращено.</li>
  </ol>
</section>
`,
    textZh: `<section class="policy">
    <h1 style="color:#f5272b;text-align:center;margin-bottom:20px;">机场接送服务政策</h1>
  <h2>费用包含</h2>
  <ol>
    <li>司机</li>
    <li>交通工具</li>
    <li>市内机场停车</li>
    <li>燃油</li>
  </ol>

  <h2 style="margin-top:8px">价格 / 备注</h2>
  <ol>
    <li>请确认您已登机并降落在努拉莱国际机场。</li>
    <li>
      接机点位于最末端的Solaria餐厅。如果您想在机场周围请求其他接机点，可以联系Wirasana Rent a Car WhatsApp群组。
    </li>
    <li>有关负责司机的详细信息将在当天提供。</li>
    <li>凭证仅适用于一次直达接机/单程送机。</li>
    <li>
      在餐厅午餐或用餐或其他停靠的额外停靠点将产生<strong>IDR 100,000/小时</strong>的额外费用（必须在前往目的地的同一路线上）。否则费用将按6小时或12小时预订费用计算。
    </li>
    <li>
      不允许在车内吃喝可能导致溢出/留下气味的食物和饮料。将收取从<strong>IDR 1,500,000</strong>起的清洁/补偿费。
    </li>
    <li>
      司机免费等待时间：
      <ul>
        <li>国内航班：从预订时间起最多45分钟</li>
        <li>国际航班：从预订时间起最多2小时</li>
      </ul>
      如果等待时间超过免费限额，适用以下额外费用：
      <ul>
        <li><strong>IDR 100,000/小时</strong>: Agya, Calya, Mobilio, Ertiga, Avanza, Terios, Grand New Innova, Innova Reborn, Jazz, Yaris, Xpander, Altis, Vios</li>
        <li><strong>IDR 200,000/小时</strong>: Alphard, Hiace, Fortuner, Pajero</li>
        <li><strong>IDR 300,000/小时</strong>: Camry, Alphard Transformer, 巴士</li>
      </ul>
    </li>
  </ol>

  <h2 style="margin-top:8px">重新安排</h2>
  <ol>
    <li>
      如果通知在预定时间前不到<strong>24小时</strong>给出，则无法确认地点、时间或接机目的地的重新安排（以避免操作设置错误），除非司机或车辆分配仍然允许。
    </li>
    <li>重新安排接机地点将根据地点产生从<strong>IDR 100,000</strong>起的额外费用（最多2次更改）。</li>
    <li>
      如果航空公司延误，请附上证明。我们的司机会尽量按照最新时间表到达，我们将确认（免费）。但是，使用的车辆类型将根据最新时间表的可用性而定。
    </li>
  </ol>

  <h2 style="margin-top:8px">取消政策</h2>
  <ol>
    <li>当天取消：付款不予退还。</li>
    <li>提前1天取消：将退还50%的付款。</li>
    <li>提前7天取消：将退还100%的付款。</li>
  </ol>
</section>
`,
  },
];

export function getPolicyHtml(type, lang) {
  const policy = policies.find((p) => p.type === type);

  if (!policy) {
    return `<p style="color:red;">No policy found for type: ${type}</p>`;
  }

  const key = `text${lang.charAt(0).toUpperCase()}${lang.slice(1)}`;

  return policy[key] || policy.textEn || `<p>No policy available</p>`;
}
